// 2024-10-07T09:50:14.839Z  (1728294614839)
export const locale = {
	lang: 'ru',
	data: {
		'ACCOUNTING_VALUE': 'Учетная стоимость',
		'ACCOUNTING_VALUE.COMPUTE_IN_STATES': 'Расчет в состояниях',
		'ACCOUNTING_VALUE.VALUE_AGGREGATION': 'Расчет значений',
		'ACCOUNTING_VALUE.VALUE_COMPUTATION': 'Расчет стоимости',
		'ACCOUNTING_VALUE.VALUE_SUMMATION': 'Суммирование значений',
		'ACCOUNT_ACTIVATION': 'Активация аккаунта',
		'ACCOUNT_ACTIVATION.CODE': 'Код активации',
		'ACCOUNT_ACTIVATION.CODE.RESEND': 'Отправить код активации повторно',
		'ACCOUNT_ACTIVATION.INTRO': 'Пожалуйста, введите код активации, который вы получили по электронной почте',
		'ACID': 'Кислота',
		'ACTIVATE': 'Активировать',
		'ACTIVATE.SELECTED': 'Активировать выбранные',
		'ACTIVE': 'Активный',
		'ACTIVITIES.DAILY': 'Дневные активности',
		'ACTIVITIES.EXPORT': 'Экспортная деятельность',
		'ACTIVITIES.NO': 'Активности отсутствуют',
		'ACTIVITIES.WEEKLY': 'Активности за неделю',
		'ACTIVITY': 'Активность',
		'ACTIVITY.EXPORT_DETAILS': 'Экспорт выбранной активности',
		'ACTIVITY.NO_FIELDS_WORKED': 'Работа на этих полях отсутствует',
		'ADAPTER': 'Адаптер',
		'ADAPTER.ASSIGN': 'Назначить адаптер',
		'ADAPTER.ASSIGN.FAILURE': 'Произошла ошибка при подключении адаптера',
		'ADAPTER.ASSIGN.SUCCESS': 'Адаптер успешно назначен',
		'ADAPTER.ASSIGNED_MACHINE': 'Назначенная техника',
		'ADAPTER.ASSIGNMENT': 'Назначение адаптеров к технике',
		'ADAPTER.CHOSEN': 'Выбранный адаптер',
		'ADAPTER.LOAD.FAILURE': 'При загрузке адаптеров произошла ошибка',
		'ADAPTER.NO': 'Адаптер отсутствует',
		'ADAPTER.NONE_AVAILABLE': 'Нет доступных адаптеров',
		'ADAPTER.PAIR_INFO': 'Выберите соответствующий адаптер. Уже назначенные адаптеры будут перезаписаны с новой машиной. Новая конфигурация будет автоматически загружена при следующем перезапуске адаптера.',
		'ADAPTER.PREVIOUS': 'Предыдущий адаптер',
		'ADAPTERS.NO': 'Адаптеры отсутствуют',
		'ADBLUE.LEVEL': 'Уровень AdBlue',
		'ADD': 'Добавить',
		'ADDITIONAL_VALUE': 'Дополнительная стоимость',
		'ADDITIVE': 'Добавка',
		'ADDRESS': 'Адрес',
		'ALL': 'Все',
		'ALL_DEVICES': 'Общие устройства',
		'AMOUNT': 'Сумма',
		'AMOUNT.INVALID': 'Сумма недействительна',
		'AMOUNTS': 'Суммы',
		'APPLY': 'Применить',
		'ARCHIVE': 'Архив',
		'ARCHIVE.SELECTED': 'Архив выбран',
		'AREA': 'Область',
		'AREA.FIELD': 'Площадь',
		'AREA.LOCATION': 'Расположение зон',
		'AREA.PERFORMANCE': 'Площадь в час',
		'AREA.PROCESSED': 'Обработанная площадь',
		'AREA.TOTAL': 'Общая площадь',
		'AREA.WORKED': 'Рабочая зона',
		'ASSIGN': 'Назначить',
		'AUTH.REMEMBER_ME': 'Запомнить меня',
		'BACK': 'Назад',
		'BALES': 'Кипы',
		'BASIC_DATA': 'Основные данные',
		'BEACON': 'Маячок',
		'BEACON.ASSIGN': 'Назначить маячок',
		'BEACON.ASSIGN.SUCCESS': 'Маячок успешно назначен',
		'BEACON.ASSIGNED_EMPLOYEE': 'Назначенный сотрудник',
		'BEACON.ASSIGNED_IMPLEMENT': 'Назначенное оборудование',
		'BEACON.ASSIGN_TO_EMPLOYEE': 'Назначить маячок сотруднику',
		'BEACON.ASSIGN_TO_IMPLEMENT': 'Назначить маячок оборудованию',
		'BEACON.CHOSEN': 'Выбранный маячок',
		'BEACON.ERROR': 'Возникла ошибка при соединении маячка',
		'BEACON.LOAD_ERROR': 'Возникла ошибка при загрузке маячка',
		'BEACON.NONE_AVAILABLE': 'Нет доступного маячка',
		'BEACON.NO_BEACON': 'Маячок отсутствует',
		'BEACON.PAIR_INFO_EMPLOYEE': 'Выберите соответствующий маячок. Уже назначенные маячки будут перезаписаны с новым сотрудником',
		'BEACON.PAIR_INFO_IMPLEMENT': 'Выберите соответствующий маячок. Уже назначенные маячки будут перезаписаны с новым оборудованием',
		'BEACON.PREVIOUS': 'Предыдущий маячок',
		'BEACONS': 'Маячки',
		'BUILD_YEAR': 'Год выпуска',
		'BUILD_YEAR.INVALID': 'Год изготовления недействителен',
		'CAN.STATUS': 'CAN статус',
		'CANCEL': 'Отмена',
		'CHANGE': 'Изменить',
		'CHANGE.NO': 'Без изменений',
		'CHOOSE_ALL': 'Выбрать все',
		'CHOOSE_ROLE': 'Выбрать роль',
		'CHRONOLOGICAL': 'хронологический порядок',
		'CLICK_PROCESS': 'Выберите действие для получения более подробной информации',
		'CLOSE': 'Закрыть',
		'CO2.EMISSION': 'Выброс CO2',
		'CO2.PER': 'Количество СО2 на га',
		'CO2.TOTAL': 'Общее количество СО2',
		'COLOR': 'Цвет',
		'COMMENT': 'Комментарий',
		'CONDITION': 'условие',
		'CONFIRM': 'Подтвердите',
		'CONFIRM_PASSWORD': 'Подтвердите пароль',
		'CONNECT': 'Соединить',
		'CONTACT_PERSON': 'Контактное лицо',
		'CONTINUE': 'Продолжить',
		'COST': 'Стоимость',
		'COST.INVALID': 'Недействительная стоимость',
		'COST.OVERALL': 'Общая стоимость',
		'COST.OVERALL.ARRIVAL': 'Общее поступление затрат',
		'COST.OVERALL.DRIVER': 'Общий фактор затрат',
		'COST.OVERALL.FIELD_TIME': 'Общие затраты на месторождение',
		'COST.OVERALL.IMPLEMENTS': 'Реализация общей стоимости',
		'COST.OVERALL.MACHINES': 'Общие затраты на машины',
		'COST.OVERALL.PREPARATION': 'Общая подготовка затрат',
		'COST.TOTAL': 'Общая стоимость',
		'COSTS': 'Затраты',
		'COST_RATE': 'Норма расходов',
		'COUNTRY': 'Страна',
		'COVERAGE': 'Coverage',
		'COVERAGE.MAP': 'Карта покрытия',
		'COVERAGE.MAP.SETTINGS': 'Настройки карты покрытия',
		'COVERAGE.MAP.ZONES': 'Зоны',
		'CREATED': 'Создано',
		'CREATE_USER': 'Создать пользователя',
		'CROP.TYPE': 'Тип растения',
		'CROP.NO_CROP': 'Нет культуры',
		'CURRENCY': 'Валюта',
		'CUSTOMER': 'Пользователь',
		'CUSTOMER.ADD': 'Добавить нового пользователя',
		'CUSTOMER.ADD.SUCCESS': 'Пользователь успешно добавлен',
		'CUSTOMER.ASSIGN': 'Назначить пользователя',
		'CUSTOMER.DELETE.QUESTION': 'Вы действительно хотите удалить данные пользователя?',
		'CUSTOMER.DELETE.SUCCESS': 'Данные пользователя успешно удалены',
		'CUSTOMER.DETAILS': 'Детали пользователя',
		'CUSTOMER.EDIT': 'Редактировать данные пользователя',
		'CUSTOMER.EDIT.SUCCESS': 'Данные пользователя успешно отредактированы',
		'CUSTOMER.NAME': 'Имя пользователя',
		'CUSTOMER.NO': 'Пользователь отсутствует',
		'CUSTOMER.NOT_SELECTED': 'Пользователь не выбран',
    'CUSTOMER.NO.ASSIGNEE': 'Пользователь не назначен',
		'CUSTOMER.SELECT': 'Выбрать пользователя',
		'CUSTOMERS': 'Пользователи',
		'CUSTOMERS.ALL': 'Все пользователи',
		'CUSTOMERS.DELETE.FAILURE': 'Данные некоторых пользователей не могут быть удалены',
		'CUSTOMERS.DELETE.QUESTION': 'Вы действительно хотите удалить выбранных пользователей?',
		'CUSTOMERS.DELETE.SUCCESS': 'Данные пользователя успешно удалены',
		'CUSTOMERS.MANAGEMENT': 'Управление пользователями',
		'CUSTOMERS.NO': 'Пользователи отсутствуют',
		'CUSTOMERS.SELECTED': 'Выбранные пользователи',
		'CUSTOM_LABELING': 'Метки пользователя',
		'CUSTOM_LABELING.ADD_WORKSTATE': 'Добавить новое рабочее состояние',
		'CUSTOM_LABELING.DEFINE_FOR_IMPLEMENT': 'Определите метку пользователя для выбранного оборудования',
		'CUSTOM_LABELING.DEFINE_INDIVIDUAL_CONDITION': 'Определите индивидуальные условия для метки',
		'CUSTOM_LABELING.EDIT.SUCCESS': 'Редактирование метки пользователя прошло успешно',
		'CUSTOM_LABELING.INDIVIDUAL_CONDITION': 'Индивидуальное условие',
		'CUSTOM_LABELING.ISOBUS_OVERRIDE': 'Разрешить переопределение с помощью условий ISOBUS',
		'CUSTOM_LABELING.NO_LABELS_AVAILABLE': 'Нет доступных меток',
		'DASHBOARD.GPS_DATA.NO': 'Нет данных GPS',
		'DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE': 'Произошла ошибка при загрузке позиций машины',
		'DATA': 'Данные',
		'DATA.ARCHIVED.WARNING': 'Базовые данные частично или полностью заархивированы',
		'DATA.EXPORT': 'Экспорт данных',
		'DATA.INPUT': 'Data input',
		'DATA.UPDATING.WARNING': 'Базовые данные обновляются',
		'DATA_PREPARATION': 'Подготовка данных',
		'DATE': 'Дата',
		'DATE.APRIL': 'Апрель',
		'DATE.AUGUST': 'Август',
		'DATE.DECEMBER': 'Декабрь',
		'DATE.FEBRUARY': 'Февраль',
		'DATE.FRIDAY': 'Пятница',
		'DATE.FROM': 'С ',
		'DATE.JANUARY': 'Январь',
		'DATE.JULY': 'Июль',
		'DATE.JUNE': 'Июнь',
		'DATE.MARCH': 'Март',
		'DATE.MAY': 'Май',
		'DATE.MONDAY': 'Понедельник',
		'DATE.NOVEMBER': 'Ноябрь',
		'DATE.OCTOBER': 'Октябрь',
		'DATE.PERIOD': 'Период',
		'DATE.RANGE': 'Диапазон дат',
		'DATE.SATURDAY': 'Суббота',
		'DATE.SEPTEMBER': 'Сентябрь',
		'DATE.SUNDAY': 'Воскресенье',
		'DATE.THURSDAY': 'Четверг',
		'DATE.TUESDAY': 'Вторник',
		'DATE.UNTIL': 'До ',
		'DATE.WEDNESDAY': 'Среда',
		'DAY.CURRENT': 'Текущий день',
		'DAY.NEXT': 'Следующий день',
		'DAY.PREVIOUS': 'Предыдущий день',
		'DAY.SELECTED': 'Выбранный день',
		'DAYS': 'Дни',
		'DAY_ACTIVITIES': 'Дневные активности',
		'DEACTIVATE': 'Деактивировать сотрудников',
		'DEACTIVATE.SELECTED': 'Деактивировать выбранное',
		'DEADLINE': 'Срок',
		'DEADLINE.ADD': 'Добавить срок',
		'DEADLINE.ADD.SUCCESS': 'Срок успешно добавлен',
		'DEADLINE.DELETE.SUCCESS': 'Срок успешно удален',
		'DEADLINE.DONE': 'Окончание',
		'DEADLINE.DUE': 'Срок выполнения',
		'DEADLINE.DUE_IN_AT': 'Срок в/в',
		'DEADLINE.EDIT': 'Срок редактирования',
		'DEADLINE.EDIT.SUCCESS': 'Срок отредактирован',
		'DEADLINE.IS_CLOSE': 'Данный крайний срок приближается',
		'DEADLINE.IS_OVERDUE': 'Этот срок просрочен',
		'DEADLINE.OPEN': 'Открыть',
		'DEADLINE.PROCESS.SUCCESS': 'Срок успешно обработан',
		'DEADLINE.PROCESSED': 'Обработано',
		'DEADLINE.PROCESSED.SUCCESS': 'Срок успешно обработан',
		'DEADLINE.WARN': 'Крайний срок приближается',
		'DEADLINES': 'Сроки',
		'DEADLINES.NO': 'Сроки отсутствуют',
		'DEFINE_ROLE': 'Определение роли',
		'DELETE': 'Удалить ',
		'DELETE.SELECTED': 'Удалить выбранные',
		'DELETED': 'Удаленный',
		'DESCRIPTION': 'Описание',
		'DIAGRAM': 'Диаграмма',
		'DISPLAY': 'Дисплей',
		'DISPLAY_TRACK': 'Показать трек',
		'DISTANCE': 'Расстояние',
		'DISTANCE.TOTAL': 'Общее расстояние',
		'DISTANCE.WORKED': 'Пройденное расстояние',
		'DOWNLOAD': 'Скачать',
		'DRIVER': 'Водитель',
		'DRIVER.EDIT': 'Редактирование драйвера',
		'DRIVER.FIXED': 'Фиксированный водитель',
		'DRIVER.NO': 'Водитель отсутствует',
		'DRIVER.REMOVE': 'Извлеките драйвер',
		'DRIVERS': 'Водители',
		'DRIVERS.ALL': 'Все водители',
		'DRIVER_SCAN_DISABLED': 'Проверка маячков водителя неактивна',
		'DURATION': 'Продолжительность',
		'DURATION.WORKED': 'Продолжительность работы',
		'EDIT': 'Редактировать',
		'EDIT.SELECTED': 'Редактировать выбранные',
		'EDIT_USER': 'Редактировать данные пользователя',
		'EMAIL': 'Электронная почта',
		'EMAIL.ACTIVATE': 'Активировать электронную почту',
		'EMAIL.ACTIVATE.CODE': 'Код активации',
		'EMAIL.ACTIVATE.EXPLANATION': 'Если вы изменили свой адрес электронной почты, мы отправим код активации на ваш новый адрес.',
		'EMAIL.CHANGE': 'Изменить электронную почту',
		'EMAIL.CHANGE.SUCCESS': 'Электронная почта успешно изменена',
		'EMAIL.CONFIRM': 'Подтвердить электронную почту',
		'EMAIL.CURRENT': 'Текущая электронная почта',
		'EMAIL.INVALID': 'Электронная почта недействительна',
		'EMAIL.NEW': 'Новая электронная почта',
		'EMAIL.NO_MATCH': 'Адреса электронной почты не совпадают',
		'EMPLOYEE': 'Сотрудник',
		'EMPLOYEE.ACTIVATE.QUESTION': 'Вы действительно хотите активировать сотрудника?',
		'EMPLOYEE.ADD': 'Добавить сотрудника',
		'EMPLOYEE.ADD.SUCCESS': 'Сотрудник успешно добавлен',
		'EMPLOYEE.CREATE': 'Создать сотрудника',
		'EMPLOYEE.CREATE.SUCCESS': 'Сотрудник успешно создан',
		'EMPLOYEE.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать сотрудника?',
		'EMPLOYEE.DELETE.QUESTION': 'Вы действительно хотите удалить сотрудника?',
		'EMPLOYEE.EDIT': 'Редактировать сотрудника',
		'EMPLOYEE.EDIT.SUCCESS': 'Сотрудник успешно отредактирован',
		'EMPLOYEE.ROLE': 'Роль сотрудника',
		'EMPLOYEE.ROLE_OF': 'Роль сотрудника',
		'EMPLOYEES': 'Сотрудники',
		'EMPLOYEES.ACTIVATE.QUESTION': 'Вы действительно хотите активизировать сотрудников?',
		'EMPLOYEES.ACTIVATE.SUCCESS': 'Сотрудники успешно активированы',
		'EMPLOYEES.ALL': 'Все сотрудники',
		'EMPLOYEES.DEACTIVATE.FAILURE': 'Некоторых сотрудников не удалось деактивировать.',
		'EMPLOYEES.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать выбранных сотрудников?',
		'EMPLOYEES.DEACTIVATE.SUCCESS': 'Сотрудники были деактивированы',
		'EMPLOYEES.DELETE.FAILURE': 'Некоторых сотрудников не удалось удалить.',
		'EMPLOYEES.DELETE.QUESTION': 'Вы действительно хотите удалить выбранных сотрудников?',
		'EMPLOYEES.DELETE.SUCCESS': 'Сотрудники удалены',
		'EMPLOYEES.MANAGEMENT': 'Управление сотрудниками',
		'EMPLOYEES.NO': 'Нет сотрудников',
		'EMPLOYEES.NOT_SELECTED': 'Нет выбранных сотрудников',
		'EMPLOYEES.SELECTED': 'Выбранные сотрудники',
		'EMPLOYER.NO': 'Нет работодателя',
		'EMPLOYER.NOT_SELECTED': 'Работодатель не выбран',
		'EMPLOYES.NO': 'Нет сотрудников',
		'END_DRAW_MODE': 'Режим рисования отменен',
		'ENTERPRISE': 'Компания',
		'ENTERPRISE.ADD': 'Добавить компанию',
		'ENTERPRISE.ADD.EMPLOYER_REQUIRED': 'Необходимо добавить работодателя',
		'ENTERPRISE.ADD.SUCCESS': 'Empresa adicionada com sucesso',
		'ENTERPRISE.ADDED.SUCCESS': 'Успешно добавлен к компании',
		'ENTERPRISE.ENTER_ACCESS_TOKEN': 'Пожалуйста, введите код доступа для предприятия.',
		'ENTERPRISE.NAME': 'Имя компании',
		'ENTERPRISE.NOT_SELECTED': 'Нет выбранной компании',
		'ENTERPRISE.OF': 'Компания:',
		'ENTERPRISE.SETTINGS': 'Настройки компании',
		'ENTERPRISE.SETTINGS.CONFIGURATION_UPDATE.SUCCESS': 'Конфигурация предприятия успешно обновлена',
		'ENTERPRISE.SETTINGS.MACHINES_SYNC.SUCCESS': 'Машины успешно синхронизированы',
		'ENTERPRISE_LICENSE.EMPLOYEES': 'Лицензии сотрудников',
		'ENTERPRISE_LICENSE.LICENSE': 'Лицензия',
		'ENTERPRISE_LICENSE.MACHINE': 'Лицензия машины',
		'ENTERPRISE_LICENSE.MACHINES': 'Лицензии машин',
		'ENTERPRISE_MIN': 'Название компании должно содержать не менее 3 символов.',
		'ENTERPRISE_NAME_REQUIRED': 'Требуется название компании',
		'ENTERPRISE_SELECTION.ADD_ENTERPRISE': 'Добавить компанию',
		'ENTERPRISE_SELECTION.LICENSE_EXPIRED': 'Срок действия лицензии истек',
		'ENTERPRISE_SELECTION.REQUEST_TEST_ACCOUNT': 'Запросить тестовый аккаунт',
		'ENTERPRISE_STATISTICS': 'Статистика предприятия',
		'ENTERPRISE_STATISTICS.COST_DIAGRAMM': 'Диаграмма затрат',
		'ENTERPRISE_STATISTICS.PROCESS_DIVISION': 'Отделение процессов',
		'ENUM.ACCOUNTING_COMP_MODE.A': 'Все',
		'ENUM.ACCOUNTING_COMP_MODE.WT': 'Работа / Транспортировка',
		'ENUM.ACCOUNTING_MODE.AVG': 'Средний',
		'ENUM.ACCOUNTING_MODE.MAX': 'Максимум',
		'ENUM.ACCOUNTING_MODE.MED': 'Средний',
		'ENUM.ACCOUNTING_MODE.MIN': 'Минимум',
		'ENUM.ACCOUNTING_MODE.SUM': 'Сумма',
		'ENUM.ACCOUNTING_VALUE_MODE.ABSDIF': 'Абсолютная разница',
		'ENUM.ACCOUNTING_VALUE_MODE.DIR': 'Прямой',
		'ENUM.ACCOUNTING_VALUE_MODE.NEGDIF': 'Отрицательная разница',
		'ENUM.ACCOUNTING_VALUE_MODE.POSDIF': 'Положительная разница',
		'ENUM.ACCOUNTING_VALUE_MODE.TIMACT': 'Активное время',
		'ENUM.BEACONTYPE.BDrv': 'Маячок для водителя',
		'ENUM.BEACONTYPE.BImpl': 'Внедрить маячок',
		'ENUM.CAN_IDENTIFIER.A1': 'Аналог 1',
		'ENUM.CAN_IDENTIFIER.A2': 'Аналог 2',
		'ENUM.CAN_IDENTIFIER.A3': 'Аналог 3',
		'ENUM.CAN_IDENTIFIER.A4': 'Аналог 4',
		'ENUM.CAN_IDENTIFIER.AUX0_Ext_Fl': 'AUX0 внешний поток',
		'ENUM.CAN_IDENTIFIER.AUX0_Ret_Fl': 'AUX0 втягивающий поток',
		'ENUM.CAN_IDENTIFIER.AUX1_Ext_Fl': 'AUX1 внешний поток',
		'ENUM.CAN_IDENTIFIER.AUX1_Ret_Fl': 'AUX1 втягивающий поток',
		'ENUM.CAN_IDENTIFIER.AUX2_Ext_Fl': 'AUX2 внешний поток',
		'ENUM.CAN_IDENTIFIER.AUX2_Ret_Fl': 'AUX2 втягивающий поток',
		'ENUM.CAN_IDENTIFIER.AUX3_Ext_Fl': 'AUX3 внешний поток',
		'ENUM.CAN_IDENTIFIER.AUX3_Ret_Fl': 'AUX3 втягивающий поток',
		'ENUM.CAN_IDENTIFIER.AUX4_Ext_Fl': 'AUX4 внешний поток',
		'ENUM.CAN_IDENTIFIER.AUX4_Ret_Fl': 'AUX4 втягивающий поток',
		'ENUM.CAN_IDENTIFIER.Ag1avg': 'Угол 1 средний',
		'ENUM.CAN_IDENTIFIER.Ag1max': 'Угол 1 максимальный',
		'ENUM.CAN_IDENTIFIER.Ag1min': 'Угол 1 минимальный',
		'ENUM.CAN_IDENTIFIER.Ag2avg': 'Угол 2 средний',
		'ENUM.CAN_IDENTIFIER.Ag2max': 'Угол 2 максимальный',
		'ENUM.CAN_IDENTIFIER.Ag2min': 'Угол 2 минимальный',
		'ENUM.CAN_IDENTIFIER.Ag3avg': 'Угол 3 средний',
		'ENUM.CAN_IDENTIFIER.Ag3max': 'Угол 3 максимальный',
		'ENUM.CAN_IDENTIFIER.Ag3min': 'Угол 3 минимальный',
		'ENUM.CAN_IDENTIFIER.ApplAci': 'Примененная кислота',
		'ENUM.CAN_IDENTIFIER.ApplAdd': 'Примененные добавки',
		'ENUM.CAN_IDENTIFIER.ApplSlu': 'Примененное удобрение',
		'ENUM.CAN_IDENTIFIER.AxleWeight_1': 'Масса оси 1',
		'ENUM.CAN_IDENTIFIER.AxleWeight_2': 'Масса оси 2',
		'ENUM.CAN_IDENTIFIER.C1': 'Счетчик 1',
		'ENUM.CAN_IDENTIFIER.C2': 'Счетчик 2',
		'ENUM.CAN_IDENTIFIER.Chop_Act': 'Чоппер',
		'ENUM.CAN_IDENTIFIER.Circ_1_Stat': 'Unimog: состояние блока гидравлического контроля 1',
		'ENUM.CAN_IDENTIFIER.Circ_2A_Stat': 'Unimog: состояние блока гидравлического контроля 2А',
		'ENUM.CAN_IDENTIFIER.Circ_2B_Stat': 'Unimog: состояние блока гидравлического контроля 2В',
		'ENUM.CAN_IDENTIFIER.Circ_3_Stat': 'Unimog: состояние блока гидравлического контроля 3',
		'ENUM.CAN_IDENTIFIER.Circ_4_Stat': 'Unimog: состояние блока гидравлического контроля 4',
		'ENUM.CAN_IDENTIFIER.ClutSlip': 'Пробуксовка сцепления',
		'ENUM.CAN_IDENTIFIER.Cutter_Guide': 'Направляющая резака',
		'ENUM.CAN_IDENTIFIER.Cutter_GuideP': 'Направляющая резака (P)',
		'ENUM.CAN_IDENTIFIER.Cutter_Pos': 'Положение резака',
		'ENUM.CAN_IDENTIFIER.Cutter_State': 'Резак',
		'ENUM.CAN_IDENTIFIER.D1': 'Цифровой 1',
		'ENUM.CAN_IDENTIFIER.D2': 'Цифровой 2',
		'ENUM.CAN_IDENTIFIER.D3': 'Цифровой 3',
		'ENUM.CAN_IDENTIFIER.D4': 'Цифровой 4',
		'ENUM.CAN_IDENTIFIER.Driv_Lever': 'Рычаг привода',
		'ENUM.CAN_IDENTIFIER.ENG_ABLev': 'Уровень AdBlue',
		'ENUM.CAN_IDENTIFIER.ENG_FueLev': 'Уровень топлива',
		'ENUM.CAN_IDENTIFIER.ENG_FueRat': 'Расход топлива',
		'ENUM.CAN_IDENTIFIER.ENG_Spe': 'Об/мин',
		'ENUM.CAN_IDENTIFIER.ENG_Tor': 'Крутящий момент',
		'ENUM.CAN_IDENTIFIER.FHitch_Pos': 'Переднее положение сцепки',
		'ENUM.CAN_IDENTIFIER.FPTO_Eng': 'ВОМ передний активен',
		'ENUM.CAN_IDENTIFIER.FPTO_Spe': 'Скорость переднего ВОМ',
		'ENUM.CAN_IDENTIFIER.Field_Switch': 'Полевой переключатель',
		'ENUM.CAN_IDENTIFIER.Field_Switch2': 'Полевой переключатель2',
		'ENUM.CAN_IDENTIFIER.Front_Draft': 'Тяга спереди',
		'ENUM.CAN_IDENTIFIER.Front_NForce': 'Тяга (номинальная) спереди',
		'ENUM.CAN_IDENTIFIER.GB_Dir': 'Направление (наземное)',
		'ENUM.CAN_IDENTIFIER.GB_Speed': 'Скорость на земле',
		'ENUM.CAN_IDENTIFIER.GPS_Speed': 'Скорость GPS',
		'ENUM.CAN_IDENTIFIER.Gear_Sel': 'Выбранная передача',
		'ENUM.CAN_IDENTIFIER.GrainCnv_Pos': 'Положение зернового конвейера',
		'ENUM.CAN_IDENTIFIER.GrainTnk_Lev': 'Уровень зернового бункера',
		'ENUM.CAN_IDENTIFIER.HySt_Dir': 'Unimog: направление движения',
		'ENUM.CAN_IDENTIFIER.HySt_Mod': 'Unimog: состояние гидростата',
		'ENUM.CAN_IDENTIFIER.Impl_Work': 'Реализовать рабочее состояние',
		'ENUM.CAN_IDENTIFIER.JbSta': 'Работа активна',
		'ENUM.CAN_IDENTIFIER.Mot_L_Spe': 'Скорость вращения двигателя (слева)',
		'ENUM.CAN_IDENTIFIER.Mot_L_Tor': 'Крутящий момент двигателя (слева)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Spe': 'Скорость вращения двигателя (справа)',
		'ENUM.CAN_IDENTIFIER.Mot_R_Tor': 'Крутящий момент двигателя (справа)',
		'ENUM.CAN_IDENTIFIER.NO_XTR': 'Нет значения',
		'ENUM.CAN_IDENTIFIER.NUE_abs': 'SyreN: NUE absolute',
		'ENUM.CAN_IDENTIFIER.NUE_rel': 'SyreN: NUE относительно',
		'ENUM.CAN_IDENTIFIER.PHSlu': 'Удобрение pH',
		'ENUM.CAN_IDENTIFIER.PTO_Switch': 'Переключатель ВОМ',
		'ENUM.CAN_IDENTIFIER.PTO_Switch1': 'Переключатель ВОМ1',
		'ENUM.CAN_IDENTIFIER.PTO_Switch2': 'Переключатель ВОМ2',
		'ENUM.CAN_IDENTIFIER.PTO_Switch3': ' PTO_Switch3 ',
		'ENUM.CAN_IDENTIFIER.PrxSen': 'Датчик приближения',
		'ENUM.CAN_IDENTIFIER.RHitch_Pos': 'Заднее положение сцепки',
		'ENUM.CAN_IDENTIFIER.RPTO_Eng': 'Задний ВОМ активен',
		'ENUM.CAN_IDENTIFIER.RPTO_Spe': 'Скорость заднего ВОМ',
		'ENUM.CAN_IDENTIFIER.Rear_Draft': 'Тяга сзади',
		'ENUM.CAN_IDENTIFIER.Rear_NForce': 'Тяга (номинальная) сзади',
		'ENUM.CAN_IDENTIFIER.Roll': 'Скорость вращения',
		'ENUM.CAN_IDENTIFIER.Sli': 'Проскальзывание',
		'ENUM.CAN_IDENTIFIER.Spe': 'Скорость',
		'ENUM.CAN_IDENTIFIER.StrawChop_Pos': 'Положение соломорезки',
		'ENUM.CAN_IDENTIFIER.Thresh_Drum': 'Молотильный барабан',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A1': 'Давление в шинах осталось A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Lt_A2': 'Давление в шинах осталось A2',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A1': 'Давление в шинах справа A1',
		'ENUM.CAN_IDENTIFIER.TirePress_Rt_A2': 'Давление в шинах справа A2',
		'ENUM.CAN_IDENTIFIER.UnlAuger_Act': 'Состояние разгрузочного шнека',
		'ENUM.CAN_IDENTIFIER.WB_Dir': 'Направление (на основе колеса)',
		'ENUM.CAN_IDENTIFIER.WB_Speed': 'Скорость на основе колеса',
		'ENUM.CAN_IDENTIFIER.Xacc': 'Ускорение X',
		'ENUM.CAN_IDENTIFIER.Yacc': 'Ускорение Y',
		'ENUM.CAN_IDENTIFIER.Yaw': 'Отклонение от курса',
		'ENUM.CAN_IDENTIFIER.Yield_Act': 'Фактическая урожайность',
		'ENUM.CAN_IDENTIFIER.Yield_Mois': 'Влажность урожая',
		'ENUM.CAN_IDENTIFIER.Zacc': 'Ускорение Z',
		'ENUM.COSTPER.h': 'ч',
		'ENUM.COSTPER.ha': 'га',
		'ENUM.COSTPER.km': 'км',
		'ENUM.COSTPER.l': 'l',
		'ENUM.CURRENCY.DOLLAR': '$',
		'ENUM.CURRENCY.EURO': '€',
		'ENUM.CURRENCY.GBP': ' £ ',
		'ENUM.EMPLOYEEROLE.ADMIN': 'Администратор',
		'ENUM.EMPLOYEEROLE.CONSULTANT': 'Консультант',
		'ENUM.EMPLOYEEROLE.DISPONENT': 'Диспетчер',
		'ENUM.EMPLOYEEROLE.DRIVER': 'Водитель',
		'ENUM.EVENTTYPE.COMMENT': 'Сообщение',
		'ENUM.EVENTTYPE.CT': 'Счетчик',
		'ENUM.EVENTTYPE.CT_RS': 'Сброс счетчика',
		'ENUM.EVENTTYPE.CUSTOMER': 'Пользователь',
		'ENUM.EVENTTYPE.EMPL_C_IMPL': 'Сотрудник подключается к оборудованию',
		'ENUM.EVENTTYPE.EMPL_E_FIELD': 'Сотрудник въезжает на поле',
		'ENUM.EVENTTYPE.EMPL_E_MACH': 'Сотрудник заходит в трактор',
		'ENUM.EVENTTYPE.EMPL_L_FIELD': 'Сотрудник покидает поле',
		'ENUM.EVENTTYPE.EMPL_L_MACH': 'Сотрудник покидает трактор',
		'ENUM.EVENTTYPE.EMPL_P_START': 'Сотрудник начинает перерыв',
		'ENUM.EVENTTYPE.EMPL_P_STOP': 'Сотрудник заканчивает перерыв',
		'ENUM.EVENTTYPE.EMPL_UC_IMPL': 'Сотрудник разъединяет оборудование',
		'ENUM.EVENTTYPE.EMPL_W_START': 'Сотрудник начинает работу',
		'ENUM.EVENTTYPE.EMPL_W_STOP': 'Сотрудник заканчивает работу',
		'ENUM.EVENTTYPE.GTO70': 'Зерновой бункер заполнен',
		'ENUM.EVENTTYPE.JOBINFO': 'Информация о работе',
		'ENUM.EVENTTYPE.JOB_PAUSE': 'Перерыв в работе',
		'ENUM.EVENTTYPE.JOB_RESUME': 'Продолжение работы',
		'ENUM.EVENTTYPE.JOB_START': 'Начало работы',
		'ENUM.EVENTTYPE.JOB_STOP': 'Окончание работы',
		'ENUM.EVENTTYPE.L_IMPL': 'Оборудование загружено',
		'ENUM.EVENTTYPE.REFUELING': 'Заправка',
		'ENUM.EVENTTYPE.SYREN_CUSTOMER': 'Клиент SyreN',
		'ENUM.EVENTTYPE.SYREN_FIELD': 'Сиренное поле',
		'ENUM.EVENTTYPE.SYREN_SLURRY_TYPE': 'Тип шлама SyreN',
		'ENUM.EVENTTYPE.T2_ON': 'T2 онлайн',
		'ENUM.EVENTTYPE.UL_IMPL': 'Оборудование разгружено',
		'ENUM.EVENTTYPE.WEATHER': 'Погода',
		'ENUM.EVENTTYPE.WEIGHING': 'Взвешивание',
		'ENUM.EVENTTYPE.WEIGHING_TARA': 'Взвешивание (Тара)',
		'ENUM.ISO_TASKDATA_STATE.CRE': 'Создано',
		'ENUM.ISO_TASKDATA_STATE.ONM': 'На машине',
		'ENUM.ISO_TASKDATA_STATE.RDY': 'Готово',
		'ENUM.JOBGENERATIONSTATE.ARC': 'Заархивировано',
		'ENUM.JOBGENERATIONSTATE.DEL': 'Удаление',
		'ENUM.JOBGENERATIONSTATE.EDT': 'Редактирование',
		'ENUM.JOBGENERATIONSTATE.GEN': 'Генерирование',
		'ENUM.JOBGENERATIONSTATE.MER': 'Слияние',
		'ENUM.JOBGENERATIONSTATE.QUE': 'В очереди',
		'ENUM.JOBGENERATIONSTATE.READY': 'OK',
		'ENUM.JOBGENERATIONSTATE.REGEN': 'Восстановление',
		'ENUM.JOBGENERATIONSTATE.SPLT': 'Разделение',
		'ENUM.JOBGENERATIONSTATE.UPD': 'Обновление',
		'ENUM.LOCATIONTYPE.FARM': 'Ферма',
		'ENUM.LOCATIONTYPE.FUEL': 'Заправочная станция',
		'ENUM.LOCATIONTYPE.OTHERS': 'Другие',
		'ENUM.LOCATIONTYPE.STABLE': 'Конюшня',
		'ENUM.LOCATIONTYPE.WEIGHING': 'Весовая',
		'ENUM.MACHINETYPE.COMBINE': 'Комбайн',
		'ENUM.MACHINETYPE.EXCAVATOR': 'Экскаватор',
		'ENUM.MACHINETYPE.FORAGE_HARVESTER': 'Кормоуборочный комбайн',
		'ENUM.MACHINETYPE.MISC': 'Другие',
		'ENUM.MACHINETYPE.SELF_PROPELLED': 'Самоходный',
		'ENUM.MACHINETYPE.SYREN': 'Syren',
		'ENUM.MACHINETYPE.TELEHANDLER': 'Телескопический погрузчик',
		'ENUM.MACHINETYPE.TRACTOR': 'Трактор',
		'ENUM.MACHINETYPE.TRUCK': 'Грузовик',
		'ENUM.MACHINETYPE.WHEELLOADER': 'Фронтальный погрузчик',
		'ENUM.MSGUNIT.-': ' - ',
		'ENUM.MSGUNIT.AXLES': 'Оси',
		'ENUM.MSGUNIT.CUBIC_M': 'м3',
		'ENUM.MSGUNIT.DOLLAR': '$',
		'ENUM.MSGUNIT.EURO': '€',
		'ENUM.MSGUNIT.KG': 'кг',
		'ENUM.MSGUNIT.LITER': 'л',
		'ENUM.MSGUNIT.TONS': 'т',
		'ENUM.MSGUNIT.h': 'ч',
		'ENUM.MSGUNIT.ha': 'га',
		'ENUM.MSGUNIT.km': 'км',
		'ENUM.ONLY_ON_STATE.A': 'Всегда',
		'ENUM.ONLY_ON_STATE.F': 'Поле',
		'ENUM.ONLY_ON_STATE.L': 'Место положения',
		'ENUM.ONLY_ON_STATE.R': 'Дорога',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_1200': 'AgLeader InCommand 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INCOMMAND_800': 'AgLeader InCommand 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_INTEGRA': 'AgLeader Integra',
		'ENUM.TRACTOR_TERMINAL_TYPE.AL_VERSA': 'AgLeader Versa',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD': 'Amazone Amapad',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMAPAD_2': 'Amazone Amapad 2',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_3': 'Amazone Amatron 3',
		'ENUM.TRACTOR_TERMINAL_TYPE.AM_AMATRON_4': 'Amazone Amatron 4',
		'ENUM.TRACTOR_TERMINAL_TYPE.AN_L10I': 'Andeo L10i',
		'ENUM.TRACTOR_TERMINAL_TYPE.A_XY': ' A_XY ',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_1200': 'Case AFS Pro 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CA_AFS_PRO_700': 'Case AFS Pro 700',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_1200': 'CCI 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CCI_800': 'CCI 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_CEMIS_1200': 'Claas Cemis 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S10': 'Claas S10',
		'ENUM.TRACTOR_TERMINAL_TYPE.CL_S7': 'Claas S7',
		'ENUM.TRACTOR_TERMINAL_TYPE.C_S2034': 'C_S2034 ',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_ONE': 'Fendt One',
		'ENUM.TRACTOR_TERMINAL_TYPE.FE_VARIOTERMINAL_10_4': 'Fendt Varioterminal 10.4',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_2630': 'John Deere 2630',
		'ENUM.TRACTOR_TERMINAL_TYPE.JD_GEN4': 'John Deere Gen4',
		'ENUM.TRACTOR_TERMINAL_TYPE.KV_TELLUS': 'Kverneland Tellus',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME': 'Müller Elektronik Basic',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_COMFORT': 'Müller Elektronik Comfort',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_1200': 'Müller Elektronik Touch 1200',
		'ENUM.TRACTOR_TERMINAL_TYPE.ME_TOUCH_800': 'Müller Elektronik Touch 800',
		'ENUM.TRACTOR_TERMINAL_TYPE.MF_DATATRONIC_5': 'MF Datatronic 5',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR12': 'Raven CR12',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_CR7': 'Raven CR7',
		'ENUM.TRACTOR_TERMINAL_TYPE.RA_VIPER4': 'Raven Viper4',
		'ENUM.TRACTOR_TERMINAL_TYPE.RH_SMART_COMMAND': 'Reichhardt Smart Command',
		'ENUM.TRACTOR_TERMINAL_TYPE.SDF_IMONITOR3': 'SDF iMonitor3',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X25': 'Topcon x25',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X30': 'Topcon x30',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_X35': 'Topcon x35',
		'ENUM.TRACTOR_TERMINAL_TYPE.TC_XD': 'Topcon XD',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_1260': 'Trimble GFX 1260',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_GFX_750': 'Trimble GFX 750',
		'ENUM.TRACTOR_TERMINAL_TYPE.TR_TMX_2050': 'Trimble TMX 2050',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_1': 'Тип 1 (запись на USB-накопитель)',
		'ENUM.TRACTOR_TERMINAL_TYPE.TYPE_2': 'Тип 2 (не записывает на USB-накопитель)',
		'ENUM.TRANSPORTUNIT.-': '-',
		'ENUM.TRANSPORTUNIT.AXLES': 'Оси',
		'ENUM.TRANSPORTUNIT.BALE': 'Тюк',
		'ENUM.TRANSPORTUNIT.CUBIC_M': 'м³',
		'ENUM.TRANSPORTUNIT.KG': 'кг',
		'ENUM.TRANSPORTUNIT.LITER': 'л',
		'ENUM.TRANSPORTUNIT.TONS': 'т',
		'ENUM.USERROLE.ADMIN': 'Администратор',
		'ENUM.USERROLE.ENTERPRISE': 'Компания',
		'ENUM.USERROLE.SALES_FORCE_TECH': 'Техника. Saleforce',
		'ENUM.USERROLE.TRAN': 'Перевод',
		'ENUM.USERROLE.USER': 'Пользователь',
		'ENUM.USERROLE.USER_EMPL': 'Пользователь (предприятие)',
		'ENUM.USERSTATE.ACTIVE': 'Активно',
		'ENUM.USERSTATE.DISABLED': 'Неактивно',
		'ENUM.USERSTATE.NOT_VERIFIED': 'Не подтверждено',
		'ENUM.WORKSTATE.DRIVING': 'В пути',
		'ENUM.WORKSTATE.DRIVING_MISC': 'Ожидание вождения',
		'ENUM.WORKSTATE.MISC_FIELD': 'Ожидание поля',
		'ENUM.WORKSTATE.MISC_FIELD_GTF': 'Зерновой бункер заполнен',
		'ENUM.WORKSTATE.MISC_ROAD': 'Ожидание дороги',
		'ENUM.WORKSTATE.PAUSE': 'Пауза',
		'ENUM.WORKSTATE.PREPARATION': 'Подготовка',
		'ENUM.WORKSTATE.ROAD': 'Дорога',
		'ENUM.WORKSTATE.THRESHING': 'Молотьба',
		'ENUM.WORKSTATE.THRESHING_U': 'Разгрузка при обмолоте',
		'ENUM.WORKSTATE.THRESHING_W_SC': 'Молотьба с измельчителем соломы',
		'ENUM.WORKSTATE.THRESHING_W_SC_U': 'Разгрузка при обмолоте с помощью измельчителя соломы',
		'ENUM.WORKSTATE.TRANSPORT_LOADED': 'Загружено',
		'ENUM.WORKSTATE.TRANSPORT_LOADED_MISC': 'Ожидание загрузки',
		'ENUM.WORKSTATE.TRANSPORT_LOADING': 'Загрузка',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED': 'Разгружено',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADED_MISC': 'Ожидание разгрузки',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING': 'Разгрузка',
		'ENUM.WORKSTATE.TRANSPORT_UNLOADING_DRIV': 'Молотьба во время разгрузки',
		'ENUM.WORKSTATE.TURNING': 'Поворот',
		'ENUM.WORKSTATE.UNDEFINED': 'Не определено',
		'ENUM.WORKSTATE.WORKING': 'Работа',
		'ENUM.WORKSTATE.WORKING_MISC': 'Ожидание работы',
		'ERROR.NO_GPS_DATA': 'Нет данных gps для выбранной машины.',
		'ERROR_MESSAGE': 'Сообщение об ошибке',
		'EVENTS': 'События',
		'EVENTS.FIELD': 'События на поле',
		'EVENTS.NO': 'Нет событий',
		'EXA_ADAPTERS': 'Адаптер',
		'EXA_ADAPTERS.AR_ACTIVATE': 'Активировать адаптер в Agrirouter',
		'EXA_ADAPTERS.AR_DEACTIVATE': 'Удалить адаптер в Agrirouter',
		'EXA_ADAPTERS.AR_LINK_SUCCESS': 'Адаптер активирован в Agrirouter',
		'EXA_ADAPTERS.AR_UNLINK_SUCCESS': 'Адаптер удален из Agrirouter',
		'EXCEPTION.1': 'Внутренняя ошибка',
		'EXCEPTION.100': 'Недопустимое значение',
		'EXCEPTION.1000': 'Имя пользователя не заполнено',
		'EXCEPTION.10000': 'Имя файла не заполнено',
		'EXCEPTION.10001': 'Данные не заполнены',
		'EXCEPTION.10002': 'Тип формата недействителен',
		'EXCEPTION.10003': 'Тип запроса данных недействителен',
		'EXCEPTION.10004': 'Нет исходных данных',
		'EXCEPTION.1001': 'Длина имени пользователя меньше минимальной длины',
		'EXCEPTION.1002': 'Такое имя уже существует',
		'EXCEPTION.1003': 'Адрес электронной почты недействителен',
		'EXCEPTION.1004': 'Такой адрес электронной почты уже существует',
		'EXCEPTION.1005': 'Длина пароля меньше минимальной',
		'EXCEPTION.1007': 'Код подтверждения недействителен',
		'EXCEPTION.1008': 'Имя пользователя (или адрес электронной почты) недействительно',
		'EXCEPTION.101': 'Недействительная роль сотрудника',
		'EXCEPTION.1011': 'Пользователь не существует',
		'EXCEPTION.1012': 'Пользователь удален',
		'EXCEPTION.1013': 'Пользователь неактивен',
		'EXCEPTION.1014': 'Пользователь заблокирован',
		'EXCEPTION.1015': 'Пользователь не активирован',
		'EXCEPTION.1016': 'Пользователь - корпоративная учетная запись',
		'EXCEPTION.102': 'Валюта недействительна',
		'EXCEPTION.1020': 'Такой пользователь уже существует',
		'EXCEPTION.1021': 'Такой электронный адрес уже существует',
		'EXCEPTION.1022': 'Адрес электронной почты не изменился',
		'EXCEPTION.1023': 'Текущий пароль не совпадает',
		'EXCEPTION.1024': 'Такое имя пользователя уже существует',
		'EXCEPTION.1025': 'Пользователь и код не совпадают',
		'EXCEPTION.1026': 'Имя пользователя (или адрес электронной почты) недействительно',
		'EXCEPTION.1027': 'Пользователь уже активирован',
		'EXCEPTION.1028': 'Запрещено для учетных записей сотрудников, созданных для компании',
		'EXCEPTION.103': 'Транспортная единица недействительна',
		'EXCEPTION.104': 'Недопустимый тип местоположения',
		'EXCEPTION.105': 'Недопустимая единица стоимости',
		'EXCEPTION.106': 'Недействительная единица',
		'EXCEPTION.107': 'Недопустимый тип машины',
		'EXCEPTION.108': 'Статус сотрудника недействителен',
		'EXCEPTION.11000': 'Тип недействителен',
		'EXCEPTION.12000': 'Тип недействителен',
		'EXCEPTION.12002': 'Серийный номер не заполнен',
		'EXCEPTION.12003': 'Состояние работы недействительно',
		'EXCEPTION.12004': 'Состояние работы недействительно',
		'EXCEPTION.12006': 'Нет конфигурации T2',
		'EXCEPTION.12007': 'MAC пуст',
		'EXCEPTION.12008': 'MAC недействителен',
		'EXCEPTION.12009': 'Адаптер уже существует',
		'EXCEPTION.12010': 'Недопустимый тип адаптера',
		'EXCEPTION.15000': 'Время начала пусто или находится в будущем',
		'EXCEPTION.15001': 'Время остановки пусто или находится в будущем',
		'EXCEPTION.15002': 'Время остановки равно или раньше времени начала',
		'EXCEPTION.15003': 'Невозможно сгенерировать пакет SILO - нет исходных данных',
		'EXCEPTION.15004': 'Исходные данные устарели',
		'EXCEPTION.16000': 'Имя не заполнено',
		'EXCEPTION.16001': 'Назначенный клиент не существует',
		'EXCEPTION.16002': 'Список маркеров пуст',
		'EXCEPTION.16003': 'В списке маркеров должно быть не менее трех маркеров.',
		'EXCEPTION.16004': 'Площадь не заполнена',
		'EXCEPTION.16005': 'Тип маркера недействителен',
		'EXCEPTION.16006': 'Поле не содержится в задании',
		'EXCEPTION.16007': 'Размер сетки больше половины высоты и ширины поля',
		'EXCEPTION.16008': 'Нет данных для ввода',
		'EXCEPTION.16009': 'Все данные содержат одно и то же значение',
		'EXCEPTION.17000': 'Имя не заполнено',
		'EXCEPTION.17001': 'Контактное лицо не заполнено',
		'EXCEPTION.17002': 'Номер телефона не заполнен',
		'EXCEPTION.17003': 'Адрес электронной почты не заполнен',
		'EXCEPTION.17004': 'Адрес электронной почты недействителен',
		'EXCEPTION.17005': 'Адрес не заполнен',
		'EXCEPTION.17006': 'Почтовый код не заполнен',
		'EXCEPTION.17007': 'Город не заполнен',
		'EXCEPTION.17008': 'Неверный цвет ((AA) RRGGBB)',
		'EXCEPTION.18000': 'Тип недействителен',
		'EXCEPTION.19001': 'Тип недействителен',
		'EXCEPTION.19002': 'MAC пуст',
		'EXCEPTION.19003': 'MAC недействителен',
		'EXCEPTION.19004': 'Мощность меньше нуля',
		'EXCEPTION.19007': 'Сотрудник не заполнен',
		'EXCEPTION.19008': 'Маячок не для навесного оборудования',
		'EXCEPTION.19009': 'Маячок не для водителя',
		'EXCEPTION.2': 'Повторяющаяся запись',
		'EXCEPTION.200': 'Ошибка анализа типа объекта Json ',
		'EXCEPTION.2000': 'Не удалось создать код подтверждения.',
		'EXCEPTION.20000': 'Исходный объем данных недостаточен',
		'EXCEPTION.20001': 'Ошибка создания архивного файла',
		'EXCEPTION.20002': 'Ошибка загрузки архивного файла',
		'EXCEPTION.2001': 'Код подтверждения не существует',
		'EXCEPTION.2002': 'Код подтверждения недействителен',
		'EXCEPTION.201': 'Ошибка записи типа объекта в Json',
		'EXCEPTION.21000': 'Имя компании не заполнено',
		'EXCEPTION.21001': 'Компания с таким именем уже существует',
		'EXCEPTION.21002': 'Длина названия предприятия меньше минимальной',
		'EXCEPTION.21003': 'Корпоративный адрес электронной почты недействителен',
		'EXCEPTION.21004': 'Токен доступа уже существует',
		'EXCEPTION.21005': 'Компания удалена',
		'EXCEPTION.21006': 'Компания деактивирована',
		'EXCEPTION.21007': 'Компания заблокирована',
		'EXCEPTION.21008': 'Недопустимый тип компании',
		'EXCEPTION.22000': 'Нет работ для добавления',
		'EXCEPTION.22001': 'Работа не изменена',
		'EXCEPTION.23000': 'Компания не зарегистрирована',
		'EXCEPTION.23001': 'Компания уже зарегистрирована',
		'EXCEPTION.23002': 'Адаптер не зарегистрирован',
		'EXCEPTION.23003': 'Адаптер уже зарегистрирован',
		'EXCEPTION.23004': 'Не удалось зарегистрировать адаптер',
		'EXCEPTION.23005': 'Не удалось переустановить адаптер',
		'EXCEPTION.23006': 'Не удалось выключить адаптер',
		'EXCEPTION.23007': 'Не удалось опубликовать возможности vCU',
		'EXCEPTION.23008': 'Не удалось опубликовать данные vCU.',
		'EXCEPTION.23009': 'Не удалось опубликовать описание устройства vCU.',
		'EXCEPTION.23010': 'Не удалось опубликовать возможности компании',
		'EXCEPTION.23011': 'Ошибка сертификата Agrirouter! Вы обновили подключение к Agrirouter?',
		'EXCEPTION.24000': 'Имя компании не заполнено',
		'EXCEPTION.24001': 'Такое название уже существует',
		'EXCEPTION.24002': 'Длина названия компании меньше минимальной',
		'EXCEPTION.24003': 'Корпоративный адрес электронной почты недействителен',
		'EXCEPTION.24004': 'Токен доступа уже существует',
		'EXCEPTION.24005': 'Компания удалена',
		'EXCEPTION.24006': 'Компания деактивирована',
		'EXCEPTION.24007': 'Компания заблокирована',
		'EXCEPTION.25000': 'Функция недоступна для выбранного партнера',
		'EXCEPTION.25001': 'Ошибка синхронизации полей',
		'EXCEPTION.25002': 'Ошибка синхронизации машин',
		'EXCEPTION.25003': 'Ошибка синхронизации оборудования',
		'EXCEPTION.25004': 'Ошибка получения машины',
		'EXCEPTION.25005': 'Ошибка создания машины',
		'EXCEPTION.25006': 'Ошибка обновления машины',
		'EXCEPTION.25007': 'Ошибка удаления машины',
		'EXCEPTION.25008': 'Ошибка получения оборудования',
		'EXCEPTION.25009': 'Ошибка создания оборудования',
		'EXCEPTION.25010': 'Ошибка обновления оборудования',
		'EXCEPTION.25011': 'Ошибка удаления оборудования',
		'EXCEPTION.26000': 'Ошибка создания PDF-файла',
		'EXCEPTION.26001': 'Выбранное задание не является заданием с поддержкой SyreN.',
		'EXCEPTION.27000': 'Машина не поддерживает файлы TaskData',
		'EXCEPTION.27001': 'Ошибка создания файла TaskData',
		'EXCEPTION.27002': 'Ошибка загрузки файла TaskData',
		'EXCEPTION.27003': 'У машины нет назначенного адаптера',
		'EXCEPTION.27004': 'Имя не заполнено',
		'EXCEPTION.27005': 'Планируемая дата пуста',
		'EXCEPTION.27006': 'Запланированная дата не в будущем',
		'EXCEPTION.27007': 'Состояние отсутствует',
		'EXCEPTION.27008': 'Файл пуст',
		'EXCEPTION.27009': 'Имя файла не заполнено',
		'EXCEPTION.27010': 'Дата не заполнена',
		'EXCEPTION.27011': 'Дата не в будущем',
		'EXCEPTION.27012': 'Размер меньше единицы',
		'EXCEPTION.27013': 'Операция TaskData недоступна в текущем состоянии',
		'EXCEPTION.27014': 'Файл с таким именем уже существует',
		'EXCEPTION.27015': 'Нет открытых задач',
		'EXCEPTION.27016': 'Разрешен только один незагруженный файл TaskData',
		'EXCEPTION.28001': 'Тип файла не поддерживается',
		'EXCEPTION.29000': 'Обновление не разрешено (уже обработано)',
		'EXCEPTION.29001': 'Нет машины или оборудования',
		'EXCEPTION.29002': 'Допускается только машина или агрегат',
		'EXCEPTION.29003': 'Базовое значение должно быть больше нуля',
		'EXCEPTION.29004': 'Значение предупреждения должно быть больше нуля',
		'EXCEPTION.29005': 'Причитающаяся стоимость должна быть больше нуля',
		'EXCEPTION.29006': 'Должный интервал должен быть больше, чем интервал предупреждения.',
		'EXCEPTION.3000': 'Информация для входа недействительна',
		'EXCEPTION.3001': 'Аккаунт заблокирован',
		'EXCEPTION.3002': 'Аккаунт не активирован',
		'EXCEPTION.3003': 'Срок действия сеанса истек - пожалуйста, войдите снова',
		'EXCEPTION.3004': 'Другой пользователь вошел в систему с этой же учетной записью',
		'EXCEPTION.31000': 'Приложение не поддерживается',
		'EXCEPTION.4000': 'Пусто',
		'EXCEPTION.4001': 'Модель не заполнена',
		'EXCEPTION.4002': 'Год должен быть больше 1950 и не в будущем.',
		'EXCEPTION.4003': 'Стоимость меньше или равна нулю',
		'EXCEPTION.4004': 'Часы работы меньше нуля',
		'EXCEPTION.4005': 'Пробег меньше нуля',
		'EXCEPTION.4007': 'Рабочая ширина меньше нуля',
		'EXCEPTION.4008': 'Неверный цвет ((AA) RRGGBB)',
		'EXCEPTION.4009': 'Конфигурация недействительна',
		'EXCEPTION.401': 'Не авторизовано',
		'EXCEPTION.4010': 'Слишком много значений конфигурации',
		'EXCEPTION.4011': 'Недопустимая динамическая конфигурация',
		'EXCEPTION.4012': 'Тип машины не трактор',
		'EXCEPTION.4013': 'Используется максимальное количество лицензий TC',
		'EXCEPTION.4014': 'Дата в будущем',
		'EXCEPTION.4015': 'Недопустимое изменение скорости',
		'EXCEPTION.403': 'Запрещено',
		'EXCEPTION.450': 'Ошибка команды ',
		'EXCEPTION.451': 'Лицензия не требуется',
		'EXCEPTION.452': 'Недопустимый параметр фильтра',
		'EXCEPTION.5000': 'Пусто',
		'EXCEPTION.5001': 'Пусто',
		'EXCEPTION.5002': 'Год должен быть больше 1950 и не в будущем',
		'EXCEPTION.5003': 'Тип 1 не заполнен',
		'EXCEPTION.5004': 'Тип 2 недействителен',
		'EXCEPTION.5005': 'Стоимость меньше или равна нулю',
		'EXCEPTION.5006': 'Рабочая ширина меньше нуля',
		'EXCEPTION.5007': 'Транспортное значение меньше нуля',
		'EXCEPTION.5008': 'Транспортная единица недействительна',
		'EXCEPTION.5009': 'Тип 3 недействителен',
		'EXCEPTION.5010': 'Недопустимая комбинация типов',
		'EXCEPTION.5011': 'Идентификатор учета недействителен',
		'EXCEPTION.6000': 'Тип недействителен',
		'EXCEPTION.6001': 'Радиус пуст или меньше нуля',
		'EXCEPTION.6002': 'Имя не заполнено',
		'EXCEPTION.6003': 'Список маркеров пуст',
		'EXCEPTION.6004': 'В списке маркеров должно быть не менее трех маркеров',
		'EXCEPTION.6005': 'Тип маркера недействителен',
		'EXCEPTION.6006': 'Тип взвешивания недействителен',
		'EXCEPTION.700': 'Недействительно',
		'EXCEPTION.7001': 'Аккаунт не существует',
		'EXCEPTION.7002': 'Аккаунт заблокирован',
		'EXCEPTION.701': 'Формула недействительна',
		'EXCEPTION.702': 'Недействительно',
		'EXCEPTION.703': 'Условие недействительно',
		'EXCEPTION.704': 'Недействительно',
		'EXCEPTION.705': 'Недопустимый параметр рабочего состояния',
		'EXCEPTION.706': 'Недопустимое рабочее состояние для типа агрегата',
		'EXCEPTION.707': 'Ошибка создания файла',
		'EXCEPTION.800': 'Имя значения конфигурации недействительно',
		'EXCEPTION.8000': 'Работодатель пуст',
		'EXCEPTION.8001': 'Сотрудник пуст',
		'EXCEPTION.8002': 'Сотрудник не найден для работодателя',
		'EXCEPTION.8003': 'Стоимость меньше нуля',
		'EXCEPTION.8004': 'Максимальное количество пользовательских лицензий получено',
		'EXCEPTION.8005': 'Не является вашим сотрудником',
		'EXCEPTION.8006': 'Сотрудник уже существует',
		'EXCEPTION.8007': 'Токен доступа пуст',
		'EXCEPTION.8008': 'Токен доступа недействителен',
		'EXCEPTION.8009': 'В компании должен быть хотя бы один администратор',
		'EXCEPTION.8010': 'Пользователь может быть подключен только к тому предприятию, которое его создало.',
		'EXCEPTION.900': 'Не существует',
		'EXCEPTION.9000': 'Время начала пусто или в будущем',
		'EXCEPTION.9001': 'Время остановки пусто или в будущем',
		'EXCEPTION.9002': 'Время остановки равно или меньше времени начала',
		'EXCEPTION.9003': 'Водитель не является сотрудником владельца работы',
		'EXCEPTION.9004': 'Оборудование не принадлежит владельцу работы',
		'EXCEPTION.9005': 'Тип 1 недействителен',
		'EXCEPTION.9006': 'Тип 2 недействителен',
		'EXCEPTION.9007': 'Тип 3 недействителен',
		'EXCEPTION.9008': 'Невозможно создать задание - нет исходных данных',
		'EXCEPTION.9009': 'Собственник машины не совпадает с владельцем оборудования',
		'EXCEPTION.901': 'Уже существует',
		'EXCEPTION.9010': 'Работа уже существует',
		'EXCEPTION.9012': 'Работа не готова',
		'EXCEPTION.9013': 'Работа отмечена для удаления',
		'EXCEPTION.9014': 'Работа заархивирована - нет доступных работ',
		'EXCEPTION.9015': 'Исходные данные устарели',
		'EXCEPTION.9016': 'Как минимум одна работа является частью задачи',
		'EXCEPTION.9017': 'Задания не совпадают (машина, водитель, навесное оборудование должны совпадать)',
		'EXCEPTION.9018': 'Разрыв между работами слишком велик',
		'EXCEPTION.9019': 'Как минимум одна работа является частью задачи',
		'EXCEPTION.902': 'Собственник не существует',
		'EXCEPTION.9020': 'Без разделения времени',
		'EXCEPTION.9021': 'Время разделения не больше времени начала и меньше времени остановки',
		'EXCEPTION.9022': 'Нет идентификаторов работ для слияния',
		'EXCEPTION.9023': 'Требуется как минимум две работы',
		'EXCEPTION.9024': 'Плотность точек должна быть больше нуля и меньше или равна единице',
		'EXCEPTION.903': 'Объект с идентификатором не существует',
		'EXCEPTION.904': 'Широта вне диапазона',
		'EXCEPTION.905': 'Долгота вне допустимого диапазона',
		'EXCEPTION.906': 'Владелец не соответствует',
		'EXCEPTION.907': 'Параметр пуст',
		'EXCEPTION.99': 'Параметр недействителен',
		'EXPORT': 'Экспорт ',
		'EXPORT.FILTERED_JOBS': 'Экспорт всех отфильтрованных работ',
		'EXPORT.JOB_DETAILS': 'Экспорт сведений о работе',
		'EXPORT.OPERATIONS.CUSTOMER.PERIOD': 'Экспорт всех данных по клиенту за выбранный период',
		'EXPORT.OPERATIONS.FIELDS.PERIOD': 'Экспорт всех операций с полями за выбранный период',
		'EXPORT.OPERATIONS.LOCATIONS.PERIOD': 'Экспорт всех операций на локациях за выбранный период',
		'EXPORT.POINTS': 'Точки данных',
		'EXPORT.POLYGONS': 'Полигоны',
		'EXPORT.RAW_DATA_AS_SILO': 'Экспорт в виде файла SILO',
		'EXPORT.SELECTED': 'Выбран экспорт',
		'EXPORT.SELECT_DATA': 'Выберите данные, которые будут включены в отчет в формате PDF',
		'EXPORT.SELECT_PERIOD': 'Выберите период для экспорта:',
		'FIELD': 'Поле',
		'FIELD.ADD': 'Добавить поле',
		'FIELD.ADD.SUCCESS': 'Поле успешно добавлено',
		'FIELD.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать поле?',
		'FIELD.DEACTIVATE.SUCCESS': 'Поле успешно деактивировано',
		'FIELD.DELETE.QUESTION': 'Вы действительно хотите удалить поле?',
		'FIELD.DELETE.SUCCESS': 'Поле успешно удалено',
		'FIELD.DETAILS': 'Детали поля',
		'FIELD.DRAW.START': 'Нарисовать границы поля на карте!',
		'FIELD.EDIT.SUCCESS': 'Поле успешно отредактировано',
		'FIELD.INTERPOLATE': 'Вводить',
		'FIELD.INTERPOLATED_VALUES': 'Введенные значения',
		'FIELD.INTERPOLATION': 'Введение',
		'FIELD.INTERPOLATION_SETTINGS': 'Настройки ввода',
		'FIELD.INTERPOLATION_SETTINGS.FINE': 'Отлично',
		'FIELD.INTERPOLATION_SETTINGS.FINE+': 'Очень хорошо',
		'FIELD.INTERPOLATION_SETTINGS.ROUGH': 'Грубый',
		'FIELD.INTERPOLATION_SETTINGS.STANDARD': 'Стандартный',
		'FIELD.NUMBER': 'Номер поля',
		'FIELD.PROCESSED': 'Обработанное поле',
		'FIELDS': 'Поля',
		'FIELDS.ALL': 'Все поля',
		'FIELDS.DEACTIVATE.FAILURE': 'Некоторые поля не удалось деактивировать.',
		'FIELDS.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать поля?',
		'FIELDS.DEACTIVATE.SUCCESS': 'Поля успешно деактивированы',
		'FIELDS.DELETE.FAILURE': 'Не удалось удалить некоторые поля',
		'FIELDS.DELETE.QUESTION': 'Вы действительно хотите удалить выбранные поля?',
		'FIELDS.DELETE.SUCCESS': 'Поля успешно удалены',
		'FIELDS.EDIT': 'Редактировать поля',
		'FIELDS.IMPORT': 'Импорт полей',
		'FIELDS.IMPORT.ASSIGN_CUSTOMER.QUESTION': 'Вы хотите назначить клиента к выбранным полям?',
		'FIELDS.IMPORT.SHAPE': 'Пожалуйста, выберите формат SHAPE для импорта',
		'FIELDS.IMPORT.SUCCESS': 'Поля успешно импортированы',
		'FIELDS.MANAGEMENT': 'Управление полями',
		'FIELDS.NO': 'Поля отсутствуют',
		'FIELDS.NOT_SELECTED': 'Нет выбранных полей',
		'FIELDS.REACTIVATE.FAILURE': 'Некоторые поля не удалось активировать повторно.',
		'FIELDS.REACTIVATE.QUESTION': 'Вы действительно хотите повторно активировать выбранные поля?',
		'FIELDS.REACTIVATE.SUCCESS': 'Поля успешно активированы',
		'FIELDS.SELECT': 'Выберите поля',
		'FIELDS.SELECTED': 'Выбранные поля',
		'FILE': 'Файл',
		'FILE.GENERATING': 'Файл создается и добавляется в файловый менеджер в ближайшее время',
		'FILE.GENERATING.READY': 'Новый файл готов к загрузке',
		'FILE.MANAGER': 'Файловый менеджер',
		'FILE.NO_FILES': 'Нет существующих файлов',
		'FILE.UPLOAD': 'Загрузить файл',
		'FILE_TRANSFER': 'Управление ISOTaskData',
		'FILE_TRANSFER.ADD': 'Добавить ISOTaskData',
		'FILE_TRANSFER.ADD.SUCCESS': 'ISOTaskData успешно добавлен',
		'FILE_TRANSFER.CREATE': 'Добавить ISOTaskData',
		'FILE_TRANSFER.DELETE.QUESTION': 'Вы действительно хотите удалить ISOTaskData?',
		'FILE_TRANSFER.DELETE.SUCCESS': 'ISOTaskData успешно удален',
		'FILE_TRANSFER.FINISHED_TASKS': 'Готовые задания',
		'FILE_TRANSFER.NO': 'Нет ISOTaskData',
		'FILE_TRANSFER.QUEUED_TASKS': 'Задания в очереди',
		'FILTER': 'Фильтр',
		'FIRMWARE_VERSION': 'Версия прошивки',
		'FIRSTNAME': 'Имя',
		'FORMS.FILE_TOO_LARGE': 'Файл слишком большой',
		'FORMS.NO_PASSWORD_MATCH': 'Пароли не соответствуют!',
		'FORMS.REQUIRED': 'Обязательно',
    'FORMS.INVALID_EMAIL': 'Неверный формат электронной почты',
		'FORMULA': 'Формула',
		'FUEL': 'Топливо',
		'FUEL.CONSUMPTION': 'Расход топлива',
		'FUEL.CONSUMPTION.AREA': 'Расход топлива на площадь',
		'FUEL.CONSUMPTION.AVERAGE': 'Средний расход топлива',
		'FUEL.CONSUMPTION.OVERALL': 'Общий расход топлива',
		'FUEL.CONSUMPTION.TOTAL': 'Общий расход топлива',
		'FUEL.COST': 'Стоимость топлива',
		'FUEL.LEVEL': 'Уровень топлива',
		'FUEL.PRICE_PER_LITER': 'Стоимость топлива за литр',
		'FUEL.WARNING': 'Низкий уровень топлива!',
		'GENERAL_INSPECTION': 'Общий обзор',
		'GEOMETRIES.UPDATE': 'Обновление полей и местоположений',
		'GEOMETRY.ADD.REGENERATION_NEEDED': 'После добавления новой геометрии все базовые данные должны быть обновлены, чтобы правильно назначить их. Хотите ли вы обновить данные сейчас?',
		'GEOMETRY.CLICK_TO_SAVE': 'Чтобы сохранить, нажмите на карта.',
		'GPS': 'GPS',
		'GPS.GPS': 'Внутренний GPS',
		'GPS.LP': 'Последняя известная позиция',
		'GPS.RTK': 'RTK',
		'GPS.RTK_H': 'RTK (высокая точность)',
		'GPS.STATUS': 'GPS статус',
		'GPS_HITCH_DISTANCE.IMPLEMENT.INFO': 'For recording the machine track correctly you need to input the distance between the hitch (A) and the point of application of the implement (B). The distance is measured in cm.',
		'GPS_HITCH_DISTANCE.MACHINE.INFO': 'For recording the machine track correctly you need to input the distance between the GPS receiver (A) and the hitch of the machine (B). The distance is measured in cm.',
		'GPS_TO_HITCH_DISTANCE': 'Расстояние от GPS до автостопа',
		'HARDWARE': 'Аппаратное обеспечение',
		'HARDWARE.SETUP.PRINT_STICKER': 'Печать наклейки на оборудование',
		'HARDWARE.SETUP.PRINT_STICKER_PACKAGING': 'Печать наклеек на упаковку',
		'HARDWARE.SETUP.RESET_DEVICE': 'Сброс устройства',
		'HARDWARE.SETUP.SET_SERIAL': 'Установите последовательный',
		'HEADLAND.PASSES': 'Headland passes',
		'HELPER_MODEL_TEXT': 'Модель в соответствии с вводом',
		'HINT_MARKERS.SHOW': 'Показать маркеры подсказок',
		'HITCH_TO_APPLICATION_DISTANCE': 'Расстояние от крюка до места применения',
		'HOME': 'Добро пожаловать',
		'HOME.CONTACTREPLY1': 'Будем рады Вашему звонку',
		'HOME.CONTACTREPLY2': 'или отправьте нам письмо по электронной почте',
		'HOME.INTRODUCTORY_VIDEOS': 'Вступительные видео',
		'HOME.NEWSINFO1': 'Все новости и информацию про управление автопарком и отслеживанию машин можно найти на нашем',
		'HOME.NEWSINFO2': 'или на нашем',
		'HOME.PROFILEEXPLANATION': 'В разделе «Мой профиль» вы можете изменить свои личные данные, адрес электронной почты и пароль.',
		'HOME.QUESTIONSYSTEM': 'У вас есть вопросы о нашей системе?',
		'HOME.TITLE': 'Добро пожаловать',
		'HOME.WELCOMEAREA': 'Добро пожаловать на вашу площадь!',
		'IDLE': 'Холостой',
		'IGNORE': 'Игнорировать',
		'IMPLEMENT': 'Оборудование',
		'IMPLEMENT.ADD': 'Добавить оборудование',
		'IMPLEMENT.ADD.SUCCESS': 'Оборудование успешно добавлено',
		'IMPLEMENT.CLASS': 'Класс оборудования',
		'IMPLEMENT.DELETE.QUESTION': 'Вы действительно хотите удалить оборудование?',
		'IMPLEMENT.DELETE.SUCCESS': 'Оборудование успешно удалено',
		'IMPLEMENT.DETAILS': 'Детали оборудования',
		'IMPLEMENT.EDIT': 'Редактировать оборудование',
		'IMPLEMENT.EDIT.SUCCESS': 'Оборудование успешно отредактировано',
		'IMPLEMENT.FIXED': 'Зафиксированное оборудование',
		'IMPLEMENT.NO': 'Нет оборудования',
		'IMPLEMENT.PROCESS.0': 'Работа без оборудования',
		'IMPLEMENT.PROCESS.1': 'Пакетирование круглых тюков',
		'IMPLEMENT.PROCESS.10': 'Прокатка',
		'IMPLEMENT.PROCESS.11': 'Посев',
		'IMPLEMENT.PROCESS.12': 'Посадка',
		'IMPLEMENT.PROCESS.13': 'Внесение удобрений',
		'IMPLEMENT.PROCESS.14': 'Опрыскивание',
		'IMPLEMENT.PROCESS.15': 'Орошение',
		'IMPLEMENT.PROCESS.16': 'Покос',
		'IMPLEMENT.PROCESS.17': 'Сбор',
		'IMPLEMENT.PROCESS.18': 'Транспортировка',
		'IMPLEMENT.PROCESS.19': 'Уборка',
		'IMPLEMENT.PROCESS.2': 'Пакетирование квадратных тюков',
		'IMPLEMENT.PROCESS.20': 'Уборка и вывоз снега',
		'IMPLEMENT.PROCESS.21': 'Распространение соли',
		'IMPLEMENT.PROCESS.22': 'Рыхление',
		'IMPLEMENT.PROCESS.23': 'Внесение удобрений',
		'IMPLEMENT.PROCESS.24': 'Перекачка жидкого навоза',
		'IMPLEMENT.PROCESS.25': 'Смешивание навоза',
		'IMPLEMENT.PROCESS.26': 'Посадка картофеля',
		'IMPLEMENT.PROCESS.27': 'Уборка картофеля',
		'IMPLEMENT.PROCESS.28': 'Разделение',
		'IMPLEMENT.PROCESS.29': 'Формирование гребня',
		'IMPLEMENT.PROCESS.3': 'Упаковка для тюков',
		'IMPLEMENT.PROCESS.30': 'Верхняя часть ботвы',
		'IMPLEMENT.PROCESS.31': 'Валкование',
		'IMPLEMENT.PROCESS.32': 'Боронование',
		'IMPLEMENT.PROCESS.33': 'Боронование',
		'IMPLEMENT.PROCESS.34': 'Измельчение',
		'IMPLEMENT.PROCESS.35': 'Уборка',
		'IMPLEMENT.PROCESS.36': 'Метель',
		'IMPLEMENT.PROCESS.37': 'Перемещение контейнеров для жидкого навоза',
		'IMPLEMENT.PROCESS.38': 'Формирование грядки',
		'IMPLEMENT.PROCESS.39': 'Подкормка',
		'IMPLEMENT.PROCESS.4': 'упаковка тюков',
		'IMPLEMENT.PROCESS.40': 'Перемещение древесины',
		'IMPLEMENT.PROCESS.41': 'Пиление древесины',
		'IMPLEMENT.PROCESS.42': 'Распил древесины',
		'IMPLEMENT.PROCESS.43': 'Фрезерование пней',
		'IMPLEMENT.PROCESS.44': 'Загрузка сыпучих материалов',
		'IMPLEMENT.PROCESS.45': 'Загрузка поддонов',
		'IMPLEMENT.PROCESS.46': 'Загрузка тюков',
		'IMPLEMENT.PROCESS.47': 'CCM mills convert',
		'IMPLEMENT.PROCESS.48': 'Толкание',
		'IMPLEMENT.PROCESS.49': 'Передний / задний вес',
		'IMPLEMENT.PROCESS.5': 'Вспашка',
		'IMPLEMENT.PROCESS.50': 'Молотьба',
		'IMPLEMENT.PROCESS.51': 'Измельчение',
		'IMPLEMENT.PROCESS.52': 'Пакетирование тюков высокого давления',
		'IMPLEMENT.PROCESS.53': 'Unleafing',
		'IMPLEMENT.PROCESS.54': 'Строгание',
		'IMPLEMENT.PROCESS.55': 'Пашня',
		'IMPLEMENT.PROCESS.56': 'Подстригание',
		'IMPLEMENT.PROCESS.57': 'Монтажные работы',
		'IMPLEMENT.PROCESS.58': 'Погрузка',
		'IMPLEMENT.PROCESS.59': 'Загрузка и разгрузка',
		'IMPLEMENT.PROCESS.6': 'Культивация',
		'IMPLEMENT.PROCESS.60': 'Мойка',
		'IMPLEMENT.PROCESS.61': 'Уплотнение',
		'IMPLEMENT.PROCESS.7': 'Боронование',
		'IMPLEMENT.PROCESS.8': 'Глубокое рыхление',
		'IMPLEMENT.PROCESS.9': 'Силовое боронование',
		'IMPLEMENT.PROCESS.deadhead': 'Без реализации',
		'IMPLEMENT.REMOVE': 'Удалить орудие',
		'IMPLEMENT.RESOURCE.0': 'не определено',
		'IMPLEMENT.RESOURCE.1': 'Корм',
		'IMPLEMENT.RESOURCE.10': 'Навоз',
		'IMPLEMENT.RESOURCE.11': 'Жидкий навоз',
		'IMPLEMENT.RESOURCE.12': 'Компост',
		'IMPLEMENT.RESOURCE.13': 'Дигестат',
		'IMPLEMENT.RESOURCE.14': 'Щепки',
		'IMPLEMENT.RESOURCE.15': 'Кукуруза',
		'IMPLEMENT.RESOURCE.16': 'Подсолнечник',
		'IMPLEMENT.RESOURCE.17': 'Сорго',
		'IMPLEMENT.RESOURCE.18': 'Рожь',
		'IMPLEMENT.RESOURCE.19': 'Тритикале',
		'IMPLEMENT.RESOURCE.2': 'Силос из травы',
		'IMPLEMENT.RESOURCE.20': 'Пшеница',
		'IMPLEMENT.RESOURCE.21': 'Бобы полевые',
		'IMPLEMENT.RESOURCE.22': 'Горох',
		'IMPLEMENT.RESOURCE.23': 'Полевая трава',
		'IMPLEMENT.RESOURCE.24': 'Клеверная трава',
		'IMPLEMENT.RESOURCE.25': 'Ячмень',
		'IMPLEMENT.RESOURCE.26': 'Овес',
		'IMPLEMENT.RESOURCE.27': 'Пшеница спельта',
		'IMPLEMENT.RESOURCE.28': 'Камелина',
		'IMPLEMENT.RESOURCE.29': 'Льняное семя',
		'IMPLEMENT.RESOURCE.3': 'Силос из цельных растений',
		'IMPLEMENT.RESOURCE.30': 'Рапс',
		'IMPLEMENT.RESOURCE.31': 'Соя',
		'IMPLEMENT.RESOURCE.32': 'Промежуточная культура',
		'IMPLEMENT.RESOURCE.33': 'Сахарная свекла',
		'IMPLEMENT.RESOURCE.34': 'Картошка',
		'IMPLEMENT.RESOURCE.35': 'Мискантус',
		'IMPLEMENT.RESOURCE.36': 'Топинамбур',
		'IMPLEMENT.RESOURCE.37': 'Овощи',
		'IMPLEMENT.RESOURCE.38': 'Клубника',
		'IMPLEMENT.RESOURCE.39': 'Жидкое удобрение',
		'IMPLEMENT.RESOURCE.4': 'Сено',
		'IMPLEMENT.RESOURCE.40': 'Лайм',
		'IMPLEMENT.RESOURCE.41': 'Диаммонфосфат',
		'IMPLEMENT.RESOURCE.42': 'Haar flour pellets, PK, K, P, KAS',
		'IMPLEMENT.RESOURCE.43': 'Мочевина',
		'IMPLEMENT.RESOURCE.44': 'Дизель',
		'IMPLEMENT.RESOURCE.45': 'AdBlue',
		'IMPLEMENT.RESOURCE.46': 'Земля',
		'IMPLEMENT.RESOURCE.47': 'Средство защиты растений',
		'IMPLEMENT.RESOURCE.48': 'Разнообразный',
		'IMPLEMENT.RESOURCE.49': 'Вода',
		'IMPLEMENT.RESOURCE.5': 'CCM',
		'IMPLEMENT.RESOURCE.50': 'Кормовая смесь',
		'IMPLEMENT.RESOURCE.6': 'Кукуруза',
		'IMPLEMENT.RESOURCE.7': 'Солома',
		'IMPLEMENT.RESOURCE.8': 'Кукурузный силос',
		'IMPLEMENT.RESOURCE.9': 'Зерно',
		'IMPLEMENT.TYPE': 'Тип оборудования',
		'IMPLEMENT.TYPE.1': 'Пресс-подборщики / упаковщики',
		'IMPLEMENT.TYPE.10': 'Транспортные прицепы',
		'IMPLEMENT.TYPE.10_1': 'Самосвал с трехсторонней разгрузкой',
		'IMPLEMENT.TYPE.10_10': 'Низкорамный прицеп',
		'IMPLEMENT.TYPE.10_11': 'Прицеп с крюковым подъемником',
		'IMPLEMENT.TYPE.10_12': 'Прицеп для перевозки скота',
		'IMPLEMENT.TYPE.10_13': 'Полуприцеп тележка',
		'IMPLEMENT.TYPE.10_14': 'Автоцистерны / Силосы',
		'IMPLEMENT.TYPE.10_2': 'Самосвал',
		'IMPLEMENT.TYPE.10_3': 'Бункер',
		'IMPLEMENT.TYPE.10_4': 'Платформа прицеп',
		'IMPLEMENT.TYPE.10_5': 'Прицеп кормоуборочный',
		'IMPLEMENT.TYPE.10_6': 'Прицеп для силоса',
		'IMPLEMENT.TYPE.10_7': 'Прицеп для перевозки тюков',
		'IMPLEMENT.TYPE.10_8': 'Прицеп с выдвижной стенкой',
		'IMPLEMENT.TYPE.10_9': 'Цистерна для жидкого навоза',
		'IMPLEMENT.TYPE.11': 'Животноводческое оборудование',
		'IMPLEMENT.TYPE.11_1': 'Прицепной смеситель кормов',
		'IMPLEMENT.TYPE.11_2': 'Кормораздаточный вагон',
		'IMPLEMENT.TYPE.11_3': 'Приемно-разгрузочный вагон',
		'IMPLEMENT.TYPE.12': 'Лесное хозяйство',
		'IMPLEMENT.TYPE.12_1': 'Лесной прицеп',
		'IMPLEMENT.TYPE.12_2': 'Пила для дров',
		'IMPLEMENT.TYPE.12_3': 'дровокол',
		'IMPLEMENT.TYPE.12_4': 'Дровокол',
		'IMPLEMENT.TYPE.12_5': 'Измельчитель пней',
		'IMPLEMENT.TYPE.12_6': 'Лесохозяйственная лебедка',
		'IMPLEMENT.TYPE.12_7': 'Лесной мульчер',
		'IMPLEMENT.TYPE.12_8': 'Измельчитель веток',
		'IMPLEMENT.TYPE.12_8_1': 'Навесной дисковый измельчитель',
		'IMPLEMENT.TYPE.12_8_2': 'Прицепной дисковый измельчитель',
		'IMPLEMENT.TYPE.12_8_3': 'Навесной барабанный измельчитель',
		'IMPLEMENT.TYPE.12_8_4': 'Прицепной барабанный измельчитель',
		'IMPLEMENT.TYPE.12_8_5': 'Прицепной барабанный измельчитель (самоходный)',
		'IMPLEMENT.TYPE.12_9': 'Гидравлический кусторез',
		'IMPLEMENT.TYPE.13': 'Коммунальное оборудование',
		'IMPLEMENT.TYPE.13_1': 'Подметальные машины',
		'IMPLEMENT.TYPE.13_10': 'Устройство обслуживания пути',
		'IMPLEMENT.TYPE.13_11': 'Банкетный фрезерный станок',
		'IMPLEMENT.TYPE.13_12': 'Солонка - в сборе',
		'IMPLEMENT.TYPE.13_13': 'null',
		'IMPLEMENT.TYPE.13_14': 'Моечное устройство',
		'IMPLEMENT.TYPE.13_15': 'Ороситель',
		'IMPLEMENT.TYPE.13_16': 'Рабочая площадка',
		'IMPLEMENT.TYPE.13_17': 'Поверхностный мульчер',
		'IMPLEMENT.TYPE.13_18': 'Передняя часть аутригера',
		'IMPLEMENT.TYPE.13_18_1': 'Головка фрезы',
		'IMPLEMENT.TYPE.13_18_2': 'Насадка для мульчирования',
		'IMPLEMENT.TYPE.13_18_3': 'Ножницы для стрижки живой изгороди',
		'IMPLEMENT.TYPE.13_18_4': 'Корзина для очистки',
		'IMPLEMENT.TYPE.13_18_5': 'Грабли',
		'IMPLEMENT.TYPE.13_19': 'Центр/структура аутригера',
		'IMPLEMENT.TYPE.13_19_1': 'Головка фрезы',
		'IMPLEMENT.TYPE.13_19_2': 'Насадка для мульчирования',
		'IMPLEMENT.TYPE.13_19_3': 'Ножницы для стрижки живой изгороди',
		'IMPLEMENT.TYPE.13_19_4': 'Корзина для очистки',
		'IMPLEMENT.TYPE.13_19_5': 'Грабли',
		'IMPLEMENT.TYPE.13_1_1': 'Передняя подметальная машина',
		'IMPLEMENT.TYPE.13_1_2': 'Подметально-уборочная машина',
		'IMPLEMENT.TYPE.13_1_3': 'структура',
		'IMPLEMENT.TYPE.13_2': 'Снегоочиститель',
		'IMPLEMENT.TYPE.13_20': 'Задний аутригер',
		'IMPLEMENT.TYPE.13_20_1': 'Головка фрезы',
		'IMPLEMENT.TYPE.13_20_2': 'Насадка для мульчирования',
		'IMPLEMENT.TYPE.13_20_3': 'Подрезка живой изгороди',
		'IMPLEMENT.TYPE.13_20_4': 'Корзина для очистки',
		'IMPLEMENT.TYPE.13_20_5': 'Грабли',
		'IMPLEMENT.TYPE.13_21': 'Воздуходувка для листьев',
		'IMPLEMENT.TYPE.13_22': 'Bankettverdichter / Plattenverdichter',
		'IMPLEMENT.TYPE.13_3': 'Снегоочиститель - V-образный',
		'IMPLEMENT.TYPE.13_4': 'Снегоочиститель',
		'IMPLEMENT.TYPE.13_5': 'Навесной разбрасыватель',
		'IMPLEMENT.TYPE.13_6': 'Буксируемый разбрасыватель',
		'IMPLEMENT.TYPE.13_7': 'Придорожная косилка',
		'IMPLEMENT.TYPE.13_8': 'Косилка с выносной опорой',
		'IMPLEMENT.TYPE.13_9': 'Косилка',
		'IMPLEMENT.TYPE.14': 'Оборудование с фронтальной загрузкой',
		'IMPLEMENT.TYPE.14_1': 'Ковш',
		'IMPLEMENT.TYPE.14_2': 'Ковш большого объема',
		'IMPLEMENT.TYPE.14_3': 'Вилка для поддонов',
		'IMPLEMENT.TYPE.14_4': 'Захват для тюков',
		'IMPLEMENT.TYPE.14_5': 'Вилка для тюков',
		'IMPLEMENT.TYPE.14_6': 'Ковш-захват',
		'IMPLEMENT.TYPE.14_7': 'Рабочая площадка',
		'IMPLEMENT.TYPE.14_8': 'Вилы для навоза',
		'IMPLEMENT.TYPE.15': 'Приспособления для уборки урожая',
		'IMPLEMENT.TYPE.15_1': 'Резка',
		'IMPLEMENT.TYPE.15_1_1': 'Стандарт резки',
		'IMPLEMENT.TYPE.15_1_2': 'Cutting foldable',
		'IMPLEMENT.TYPE.15_2': 'Сборщик кукурузы',
		'IMPLEMENT.TYPE.15_2_1': 'Стандартный подборщик кукурузы',
		'IMPLEMENT.TYPE.15_3': 'Кукурузная жатка',
		'IMPLEMENT.TYPE.15_4': 'GPS-Vorsatz',
		'IMPLEMENT.TYPE.15_5': 'Подборщик',
		'IMPLEMENT.TYPE.15_6': 'Очистка крепления',
		'IMPLEMENT.TYPE.15_7': 'Система впуска',
		'IMPLEMENT.TYPE.15_8': 'Подбор валков',
		'IMPLEMENT.TYPE.16': 'Разное',
		'IMPLEMENT.TYPE.16_1': 'Мельница CCM',
		'IMPLEMENT.TYPE.16_2': 'Передний вес',
		'IMPLEMENT.TYPE.16_3': 'Задний вес',
		'IMPLEMENT.TYPE.16_4': 'Толкающее лезвие',
		'IMPLEMENT.TYPE.17': 'Фруктовый сад и виноградник',
		'IMPLEMENT.TYPE.17_1': 'Очистной плуг',
		'IMPLEMENT.TYPE.17_2': 'Посадочная машина',
		'IMPLEMENT.TYPE.17_3': 'Дефолиатор',
		'IMPLEMENT.TYPE.17_4': 'Фрезерный станок',
		'IMPLEMENT.TYPE.18': 'Овощеводство',
		'IMPLEMENT.TYPE.18_1': 'Комбайн для уборки моркови',
		'IMPLEMENT.TYPE.18_2': 'Лукоуборочный комбайн',
		'IMPLEMENT.TYPE.18_4': 'Луковичный комбайн',
		'IMPLEMENT.TYPE.18_5': 'Комбайн для уборки лука-порея',
		'IMPLEMENT.TYPE.19': 'Технология сахарной свеклы',
		'IMPLEMENT.TYPE.19_1': 'Свеклоуборочный комбайн - комбайн бункерный',
		'IMPLEMENT.TYPE.19_1_1': 'Бункерный комбайн',
		'IMPLEMENT.TYPE.19_1_2': 'Перегружатель',
		'IMPLEMENT.TYPE.1_1': 'Пресс-подборщик рулонный',
		'IMPLEMENT.TYPE.1_2': 'Пресс-подборщик квадратный',
		'IMPLEMENT.TYPE.1_3': 'Комбинация пакетирования / упаковки',
		'IMPLEMENT.TYPE.1_4': 'Обмотчик тюков',
		'IMPLEMENT.TYPE.1_5': 'Пресс-подборщик высокой плотности',
		'IMPLEMENT.TYPE.2': 'Обработка почвы',
		'IMPLEMENT.TYPE.2_1': 'Плуг',
		'IMPLEMENT.TYPE.2_10': 'Ротационный культиватор',
		'IMPLEMENT.TYPE.2_10_1': 'Роторный культиватор - навесной',
		'IMPLEMENT.TYPE.2_10_2': 'Роторный культиватор - прилагается',
		'IMPLEMENT.TYPE.2_11': 'Передний упаковщик',
		'IMPLEMENT.TYPE.2_12': 'Ролик',
		'IMPLEMENT.TYPE.2_12_1': 'Ролик - монтируется',
		'IMPLEMENT.TYPE.2_12_2': 'Ролик - прикреплен',
		'IMPLEMENT.TYPE.2_13': 'Ротационные бороны',
		'IMPLEMENT.TYPE.2_13_1': 'Ротационные бороны - навесные',
		'IMPLEMENT.TYPE.2_13_2': 'Ротационные бороны - навесные',
		'IMPLEMENT.TYPE.2_14': 'Ротационный культиватор',
		'IMPLEMENT.TYPE.2_14_1': 'Роторный культиватор - навесной',
		'IMPLEMENT.TYPE.2_14_2': 'Роторный культиватор - навесное оборудование',
		'IMPLEMENT.TYPE.2_15': 'Предпосевная комбинация',
		'IMPLEMENT.TYPE.2_15_1': 'Комбинированный посевной материал - навесной',
		'IMPLEMENT.TYPE.2_15_2': 'Комбинация посевного материала - прилагается',
		'IMPLEMENT.TYPE.2_16': 'Прессы',
		'IMPLEMENT.TYPE.2_17': 'Скребки',
		'IMPLEMENT.TYPE.2_17_1': 'Скребки - навесные',
		'IMPLEMENT.TYPE.2_17_2': 'Скребки - прилагаются',
		'IMPLEMENT.TYPE.2_18': 'Соломенная борона',
		'IMPLEMENT.TYPE.2_18_1': 'Соломенная борона - навесная',
		'IMPLEMENT.TYPE.2_18_2': 'Соломенная борона - прилагается',
		'IMPLEMENT.TYPE.2_19': 'Зубчатый культиватор / культиватор',
		'IMPLEMENT.TYPE.2_19_1': 'Навесные дальнейшие культиваторы - навесные',
		'IMPLEMENT.TYPE.2_19_2': 'Дальние культиваторы - прилагаются',
		'IMPLEMENT.TYPE.2_1_1': 'Навесной плуг',
		'IMPLEMENT.TYPE.2_1_2': 'Полунавесной плуг',
		'IMPLEMENT.TYPE.2_1_3': 'Плуг полунавесной (наземный)',
		'IMPLEMENT.TYPE.2_2': 'Культиватор',
		'IMPLEMENT.TYPE.2_20': 'Другие культиваторы',
		'IMPLEMENT.TYPE.2_2_1': 'Навесной культиватор',
		'IMPLEMENT.TYPE.2_2_2': 'Полунавесной культиватор',
		'IMPLEMENT.TYPE.2_3': 'Дисковая борона',
		'IMPLEMENT.TYPE.2_3_1': 'Навесная дисковая борона',
		'IMPLEMENT.TYPE.2_3_2': 'Полунавесная борона',
		'IMPLEMENT.TYPE.2_4': 'Компактная дисковая борона',
		'IMPLEMENT.TYPE.2_4_1': 'Компактная дисковая борона - навесная',
		'IMPLEMENT.TYPE.2_4_2': 'Компактная дисковая борона - прилагается',
		'IMPLEMENT.TYPE.2_5': 'Глубокорыхлитель',
		'IMPLEMENT.TYPE.2_5_1': 'Глубокий рыхлитель - монтируется',
		'IMPLEMENT.TYPE.2_5_2': 'Глубокий рыхлитель - прилагается',
		'IMPLEMENT.TYPE.2_6': 'Лопаточная машина',
		'IMPLEMENT.TYPE.2_6_1': 'Лопаточная машина - навесная',
		'IMPLEMENT.TYPE.2_6_2': 'Лопаточная машина - прилагается',
		'IMPLEMENT.TYPE.2_7': 'Ротационная борона',
		'IMPLEMENT.TYPE.2_7_1': 'Ротационная борона - навесная',
		'IMPLEMENT.TYPE.2_7_2': 'Ротационная борона - навесное оборудование',
		'IMPLEMENT.TYPE.2_8': 'Ротационная мотыга',
		'IMPLEMENT.TYPE.2_8_1': 'Роторная мотыга - навесная',
		'IMPLEMENT.TYPE.2_8_2': 'Роторная мотыга - прилагается',
		'IMPLEMENT.TYPE.2_9': 'Поршневая борона',
		'IMPLEMENT.TYPE.2_9_1': 'Рециркуляционная борона - навесная',
		'IMPLEMENT.TYPE.2_9_2': 'Рециркуляционная борона - навесное оборудование',
		'IMPLEMENT.TYPE.3': 'Сеялки / сеялки',
		'IMPLEMENT.TYPE.3_1': 'Механическая сеялка',
		'IMPLEMENT.TYPE.3_1_1': 'Навесная сеялка',
		'IMPLEMENT.TYPE.3_1_2': 'Сеялка полунавесная',
		'IMPLEMENT.TYPE.3_1_3': 'Навесная посевная комбинация',
		'IMPLEMENT.TYPE.3_1_4': 'Полунавесная посевная комбинация',
		'IMPLEMENT.TYPE.3_2': 'Пневматическая сеялка',
		'IMPLEMENT.TYPE.3_2_1': 'Навесная сеялка',
		'IMPLEMENT.TYPE.3_2_2': 'Сеялка полунавесная',
		'IMPLEMENT.TYPE.3_2_3': 'Навесная посевная комбинация',
		'IMPLEMENT.TYPE.3_2_4': 'Полунавесная посевная комбинация',
		'IMPLEMENT.TYPE.3_3': 'механическая сеялка точного высева',
		'IMPLEMENT.TYPE.3_3_1': 'Навесная сеялка',
		'IMPLEMENT.TYPE.3_3_2': 'Сеялка полунавесная',
		'IMPLEMENT.TYPE.3_3_3': 'Навесная посевная комбинация',
		'IMPLEMENT.TYPE.3_3_4': 'Полунавесная посевная комбинация',
		'IMPLEMENT.TYPE.3_4': 'Сеялка точного высева',
		'IMPLEMENT.TYPE.3_4_1': 'Навесная сеялка',
		'IMPLEMENT.TYPE.3_4_2': 'Сеялка полунавесная',
		'IMPLEMENT.TYPE.3_4_3': 'Навесная посевная комбинация',
		'IMPLEMENT.TYPE.3_4_4': 'Полунавесная посевная комбинация',
		'IMPLEMENT.TYPE.3_5': 'Сеялка прямая',
		'IMPLEMENT.TYPE.3_5_1': 'Сеялка прямого посева - навесная',
		'IMPLEMENT.TYPE.3_5_2': 'Сеялка для прямого посева - прилагается',
		'IMPLEMENT.TYPE.3_6': 'Сеялка прямого посева точного высева',
		'IMPLEMENT.TYPE.3_6_1': 'Однозерновая сеялка прямого посева - навесная',
		'IMPLEMENT.TYPE.3_6_2': 'Однозерновая сеялка прямого посева - прилагается',
		'IMPLEMENT.TYPE.3_7': 'Сеялка',
		'IMPLEMENT.TYPE.3_7_1': 'Рассадник - навесной',
		'IMPLEMENT.TYPE.3_7_2': 'Сажалка - прикреплена',
		'IMPLEMENT.TYPE.3_8': 'Сеялка для травы',
		'IMPLEMENT.TYPE.3_8_1': 'Сеялка для пастбищ - навесная',
		'IMPLEMENT.TYPE.3_8_2': 'Сеялка для пастбищ - прилагается',
		'IMPLEMENT.TYPE.3_9': 'Передний бак',
		'IMPLEMENT.TYPE.4': 'Разбрасыватель',
		'IMPLEMENT.TYPE.4_1': 'Навесной разбрасыватель',
		'IMPLEMENT.TYPE.4_2': 'Полунавесной разбрасыватель',
		'IMPLEMENT.TYPE.5': 'Защита растений',
		'IMPLEMENT.TYPE.5_1': 'Навесной опрыскиватель',
		'IMPLEMENT.TYPE.5_2': 'Прицепной опрыскиватель',
		'IMPLEMENT.TYPE.5_3': 'Прополочная / мотыга',
		'IMPLEMENT.TYPE.5_3_1': 'Мотыга - навесная',
		'IMPLEMENT.TYPE.5_3_2': 'Мотыга - прикреплена',
		'IMPLEMENT.TYPE.5_4': 'Прополка',
		'IMPLEMENT.TYPE.5_4_1': 'Прополочная машина - навесная',
		'IMPLEMENT.TYPE.5_4_2': 'Прополка - прилагается',
		'IMPLEMENT.TYPE.6': 'Технология навоза',
		'IMPLEMENT.TYPE.6_1': 'Разбрасыватель навоза / компоста',
		'IMPLEMENT.TYPE.6_2': 'Цистерна для жидкого навоза',
		'IMPLEMENT.TYPE.6_2_1': 'Точный рассеиватель',
		'IMPLEMENT.TYPE.6_2_2': 'Штанга капельного шланга',
		'IMPLEMENT.TYPE.6_2_3': 'Разбрасыватель прицепных башмаков',
		'IMPLEMENT.TYPE.6_2_4': 'Инжектор культиватора',
		'IMPLEMENT.TYPE.6_2_5': 'Инжектор дисковой бороны',
		'IMPLEMENT.TYPE.6_2_6': 'Форсунка дискового ножа',
		'IMPLEMENT.TYPE.6_2_7': 'Striptill Injektor',
		'IMPLEMENT.TYPE.6_2_8': 'Поворотный распределитель',
		'IMPLEMENT.TYPE.6_3': 'Насос для жидкого навоза',
		'IMPLEMENT.TYPE.6_4': 'Смеситель жидкого навоза',
		'IMPLEMENT.TYPE.6_5': 'Контейнер для жидкого навоза',
		'IMPLEMENT.TYPE.6_6': 'Шланговая система',
		'IMPLEMENT.TYPE.6_6_1': 'Тяговый распределитель шланга',
		'IMPLEMENT.TYPE.6_6_2': 'Drag shoe distributor',
		'IMPLEMENT.TYPE.6_6_3': 'Дисковый инжектор для жидкого навоза',
		'IMPLEMENT.TYPE.6_6_4': 'Культиватор для жидкого навоза',
		'IMPLEMENT.TYPE.6_6_5': 'Дисковая борона для внесения удобрений',
		'IMPLEMENT.TYPE.6_6_6': 'Инжектор жидкого навоза',
		'IMPLEMENT.TYPE.6_6_7': 'Поворотный распределитель',
		'IMPLEMENT.TYPE.7': 'Технология орошения',
		'IMPLEMENT.TYPE.7_1': 'Путешественник по орошению',
		'IMPLEMENT.TYPE.7_2': 'Оросительная стрела',
		'IMPLEMENT.TYPE.8': 'Оборудование для картофеля',
		'IMPLEMENT.TYPE.8_1': 'Картофельная сеялка',
		'IMPLEMENT.TYPE.8_1_1': 'Сеялка без роторного культиватора',
		'IMPLEMENT.TYPE.8_1_2': 'Сеялка с роторным культиватором',
		'IMPLEMENT.TYPE.8_1_3': 'Посадочная машина без ротационной бороны / навесного культиватора',
		'IMPLEMENT.TYPE.8_1_4': 'Посадочная машина с ротационной бороной / навесным культиватором',
		'IMPLEMENT.TYPE.8_2': 'Картофелеуборочный комбайн - косилка',
		'IMPLEMENT.TYPE.8_3': 'Картофелеуборочный комбайн - с бункером',
		'IMPLEMENT.TYPE.8_4': 'Картофелеуборочный комбайн - элеватор',
		'IMPLEMENT.TYPE.8_5': 'Ridge former',
		'IMPLEMENT.TYPE.8_6': 'Сепаратор',
		'IMPLEMENT.TYPE.8_7': 'Роторный окучник',
		'IMPLEMENT.TYPE.8_8': 'Ботворез',
		'IMPLEMENT.TYPE.9': 'Оборудование для пастбищ',
		'IMPLEMENT.TYPE.9_1': 'Барабанная косилка',
		'IMPLEMENT.TYPE.9_1_1': 'Барабанная косилка с плющилкой',
		'IMPLEMENT.TYPE.9_1_2': 'Барабанная косилка без плющилки',
		'IMPLEMENT.TYPE.9_1_3': 'Барабанная косилка с плющилкой',
		'IMPLEMENT.TYPE.9_1_4': 'Барабанная косилка без плющилки',
		'IMPLEMENT.TYPE.9_2': 'Дисковая косилка',
		'IMPLEMENT.TYPE.9_2_1': 'Дисковая косилка с плющилкой',
		'IMPLEMENT.TYPE.9_2_2': 'Дисковая косилка без плющилки',
		'IMPLEMENT.TYPE.9_2_3': 'Дисковая косилка с плющилкой',
		'IMPLEMENT.TYPE.9_2_4': 'Дисковая косилка без плющилки',
		'IMPLEMENT.TYPE.9_3': 'Ротационная сеноворошилка',
		'IMPLEMENT.TYPE.9_3_1': 'Ротационная сеноворошилка / сеноворошилка с навесным оборудованием',
		'IMPLEMENT.TYPE.9_3_2': 'Приставленная роторная ворошилка',
		'IMPLEMENT.TYPE.9_4': 'Валкователь',
		'IMPLEMENT.TYPE.9_4_1': 'Валкователь с одним ротором',
		'IMPLEMENT.TYPE.9_4_2': 'Валкообразователь двухроторный (боковая укладка валка)',
		'IMPLEMENT.TYPE.9_4_3': 'Валкователь с двумя роторами (центральная укладка валка)',
		'IMPLEMENT.TYPE.9_4_4': 'Валкователь четырехроторный',
		'IMPLEMENT.TYPE.9_4_5': 'Непрерывное слияние',
		'IMPLEMENT.TYPE.9_4_6': 'Роторные грабли',
		'IMPLEMENT.TYPE.9_5': 'Борона для лугов',
		'IMPLEMENT.TYPE.9_6': 'Пастбищная борона',
		'IMPLEMENT.TYPE.9_7': 'Каток для луга',
		'IMPLEMENT.TYPE.9_8': 'Измельчитель',
		'IMPLEMENTS': 'Оборудование',
		'IMPLEMENTS.ALL': 'Все оборудование',
		'IMPLEMENTS.DEACTIVATE.FAILURE': 'Некоторые орудия невозможно было деактивировать.',
		'IMPLEMENTS.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать выбранные инструменты?',
		'IMPLEMENTS.DEACTIVATE.SUCCESS': 'Реализации успешно деактивированы',
		'IMPLEMENTS.DELETE.FAILURE': 'Не удалось удалить некоторое оборудование',
		'IMPLEMENTS.DELETE.QUESTION': 'Вы действительно хотите удалить выбранное оборудование?',
		'IMPLEMENTS.DELETE.SUCCESS': 'Оборудование удалено',
		'IMPLEMENTS.MANAGEMENT': 'Управление оборудованием',
		'IMPLEMENTS.NO': 'Нет оборудования',
		'IMPLEMENTS.NOT_SELECTED': 'Не выбраны орудия',
		'IMPLEMENTS.REACTIVATE.FAILURE': 'Некоторые орудия не удалось привести в действие.',
		'IMPLEMENTS.REACTIVATE.QUESTION': 'Вы действительно хотите снова активировать выбранные инструменты?',
		'IMPLEMENTS.REACTIVATE.SUCCESS': 'Успешная реактивация',
		'IMPLEMENTS.SELECTED': 'Выбранное оборудование',
		'IMPLEMENT_SCAN_DISABLED': 'Сканирование маячков оборудования неактивно',
		'IMPORT': 'Импорт',
		'INACTIVE': 'Неактивно',
		'INDIVIDUAL_LABELING': 'Пользовательская маркировка',
		'INFO': 'Информация',
		'INTERPOLATION.MAP': 'Карта интерполяции',
		'INTERPOLATION.MAP.SETTINGS': 'Настройки карты интерполяции',
		'IO_BOX_ACTIVATED': 'IOBox активен',
		'ISOBUS.DDI.1': 'Установленный объем на единицу площади нормы внесения',
		'ISOBUS.DDI.10': 'Максимальная норма внесения массы на площадь',
		'ISOBUS.DDI.100': 'Загрязнение урожая',
		'ISOBUS.DDI.101': 'Заданная ширина тюка',
		'ISOBUS.DDI.102': 'Фактическая ширина тюка',
		'ISOBUS.DDI.103': 'Ширина тюка по умолчанию',
		'ISOBUS.DDI.104': 'Минимальная ширина тюка',
		'ISOBUS.DDI.105': 'Максимальная ширина тюка',
		'ISOBUS.DDI.106': 'Заданная высота тюка',
		'ISOBUS.DDI.107': 'Фактическая высота тюка',
		'ISOBUS.DDI.108': 'Высота тюка по умолчанию',
		'ISOBUS.DDI.109': 'Минимальная высота тюка',
		'ISOBUS.DDI.11': 'Количество заданных значений на норму внесения',
		'ISOBUS.DDI.110': 'Максимальная высота тюка',
		'ISOBUS.DDI.111': 'Заданный размер тюка',
		'ISOBUS.DDI.112': 'Фактический размер тюка',
		'ISOBUS.DDI.113': 'Размер тюка по умолчанию',
		'ISOBUS.DDI.114': 'Минимальный размер тюка',
		'ISOBUS.DDI.115': 'Максимальный размер тюка',
		'ISOBUS.DDI.116': 'Общая площадь',
		'ISOBUS.DDI.117': 'Эффективное общее расстояние',
		'ISOBUS.DDI.118': 'Неэффективное общее расстояние',
		'ISOBUS.DDI.119': 'Эффективное общее время',
		'ISOBUS.DDI.12': 'Фактическое количество на норму внесения',
		'ISOBUS.DDI.120': 'Неэффективное общее время',
		'ISOBUS.DDI.121': 'Плотность массы на объем',
		'ISOBUS.DDI.122': 'Плотность массы на счет',
		'ISOBUS.DDI.123': 'Объем плотности продукта на счет',
		'ISOBUS.DDI.124': 'Расширение шкалы вспомогательного клапана',
		'ISOBUS.DDI.125': 'Отвод шкалы вспомогательного клапана',
		'ISOBUS.DDI.126': 'Наклон вспомогательного клапана выдвигается вверх',
		'ISOBUS.DDI.127': 'Рампа вспомогательного клапана выдвигается вниз',
		'ISOBUS.DDI.128': 'Вспомогательный клапан втягивается с рампой вверх',
		'ISOBUS.DDI.129': 'Линия втягивания вспомогательного клапана вниз',
		'ISOBUS.DDI.13': 'Количество по умолчанию на норму внесения',
		'ISOBUS.DDI.130': 'Порог срабатывания вспомогательного клапана',
		'ISOBUS.DDI.131': 'Увеличение хода вспомогательного клапана',
		'ISOBUS.DDI.132': 'Втягивание хода вспомогательного клапана',
		'ISOBUS.DDI.133': 'Отверстия для обратного клапана вспомогательного клапана',
		'ISOBUS.DDI.134': 'Смещение элемента устройства X',
		'ISOBUS.DDI.135': 'Смещение элемента устройства Y',
		'ISOBUS.DDI.136': 'Смещение элемента устройства Z',
		'ISOBUS.DDI.137': 'Объем устройства',
		'ISOBUS.DDI.138': 'Масса устройства',
		'ISOBUS.DDI.139': 'Емкость счетчика устройств',
		'ISOBUS.DDI.14': 'Минимальная норма расхода на единицу площади',
		'ISOBUS.DDI.140': 'Заданное значение процентной нормы внесения',
		'ISOBUS.DDI.141': 'Фактическое рабочее состояние',
		'ISOBUS.DDI.142': 'Установка задержки времени',
		'ISOBUS.DDI.143': 'Фактическое значение задержки времени',
		'ISOBUS.DDI.144': 'Угол рыскания',
		'ISOBUS.DDI.145': 'Угол крена',
		'ISOBUS.DDI.146': 'Угол тангажа',
		'ISOBUS.DDI.147': 'Счетчик журнала',
		'ISOBUS.DDI.148': 'Общий расход топлива',
		'ISOBUS.DDI.149': 'Мгновенный расход топлива за время',
		'ISOBUS.DDI.15': 'Максимальное количество на одну область нормы внесения',
		'ISOBUS.DDI.150': 'Мгновенный расход топлива на площадь',
		'ISOBUS.DDI.151': 'Мгновенная площадь за время',
		'ISOBUS.DDI.153': 'Фактический NDVI',
		'ISOBUS.DDI.154': 'Физическая длина объекта',
		'ISOBUS.DDI.155': 'Физическая ширина объекта',
		'ISOBUS.DDI.156': 'Физическая высота объекта',
		'ISOBUS.DDI.157': 'Тип разъема',
		'ISOBUS.DDI.158': 'Предписание состояния контроля',
		'ISOBUS.DDI.159': 'Количество подразделений в секции',
		'ISOBUS.DDI.16': 'Интервал уставки нормы внесения',
		'ISOBUS.DDI.160': 'Состояние управления секциями',
		'ISOBUS.DDI.161': 'Рабочее положение (вкл/выкл) отдельных секций (1-16) по всей ширине захвата',
		'ISOBUS.DDI.162': 'Рабочее положение (вкл/выкл) отдельных секций (17-32) по всей ширине захвата',
		'ISOBUS.DDI.163': 'Рабочее положение (вкл/выкл) отдельных секций (33-48) по всей ширине захвата',
		'ISOBUS.DDI.164': 'Рабочее положение (вкл/выкл) отдельных секций (49-64) по всей ширине захвата',
		'ISOBUS.DDI.165': 'Рабочее положение (вкл/выкл) отдельных секций (65-80) по всей ширине захвата',
		'ISOBUS.DDI.166': 'Рабочее положение (вкл/выкл) отдельных секций (81-96) по всей ширине захвата',
		'ISOBUS.DDI.167': 'Рабочее положение (вкл/выкл) отдельных секций (97-112) по всей ширине захвата',
		'ISOBUS.DDI.168': 'Рабочее положение (вкл/выкл) отдельных секций (113-128) по всей ширине захвата',
		'ISOBUS.DDI.169': 'Рабочее положение (вкл/выкл) отдельных секций (129-144) по всей ширине захвата',
		'ISOBUS.DDI.17': 'Фактическая норма внесения',
		'ISOBUS.DDI.170': 'Рабочее положение (вкл/выкл) отдельных секций (145-160) по всей ширине захвата',
		'ISOBUS.DDI.171': 'Рабочее положение (вкл/выкл) отдельных секций (161-176) по всей ширине захвата',
		'ISOBUS.DDI.172': 'Рабочее положение (вкл/выкл) отдельных секций (177-192) по всей ширине захвата',
		'ISOBUS.DDI.173': 'Рабочее положение (вкл/выкл) отдельных секций (193-208) по всей ширине захвата',
		'ISOBUS.DDI.174': 'Рабочее положение (вкл/выкл) отдельных секций (209-224) по всей ширине захвата',
		'ISOBUS.DDI.175': 'Рабочее положение (вкл/выкл) отдельных секций (225-240) по всей ширине захвата',
		'ISOBUS.DDI.176': 'Рабочее положение (вкл/выкл) отдельных секций (241-256) по всей ширине захвата',
		'ISOBUS.DDI.177': 'Фактическая длина реза',
		'ISOBUS.DDI.178': 'Тип элемента Instance',
		'ISOBUS.DDI.179': 'Фактическая культурная практика',
		'ISOBUS.DDI.18': 'Интервал нормы внесения по умолчанию',
		'ISOBUS.DDI.180': 'Расстояние от контрольной точки устройства (DRP) до земли',
		'ISOBUS.DDI.181': 'Сухая масса на площадь урожая',
		'ISOBUS.DDI.182': 'Сухая масса на время урожая',
		'ISOBUS.DDI.183': 'Выход общей сухой массы',
		'ISOBUS.DDI.184': 'Эталонная влажность для сухой массы',
		'ISOBUS.DDI.185': 'Масса семян хлопка с площади урожая',
		'ISOBUS.DDI.186': 'Масса волокна хлопка на площадь выхода',
		'ISOBUS.DDI.187': 'Масса семян хлопка за время урожайности',
		'ISOBUS.DDI.188': 'Масса хлопкового волокна за время выхода',
		'ISOBUS.DDI.189': 'Общая масса урожая семян хлопка',
		'ISOBUS.DDI.19': 'Минимальная норма внесения',
		'ISOBUS.DDI.190': 'Общий выход хлопковой массы',
		'ISOBUS.DDI.191': 'Процент выхода хлопковой массы',
		'ISOBUS.DDI.192': 'Температура окружающей среды',
		'ISOBUS.DDI.193': 'Заданное значение давления продукта',
		'ISOBUS.DDI.194': 'Фактическое давление продукта',
		'ISOBUS.DDI.195': 'Минимальное давление продукта',
		'ISOBUS.DDI.196': 'Максимальное давление продукта',
		'ISOBUS.DDI.197': 'Установленное значение выходного давления насоса',
		'ISOBUS.DDI.198': 'Фактическое давление выходного насоса',
		'ISOBUS.DDI.199': 'Минимальное значение выходного давления насоса',
		'ISOBUS.DDI.2': 'Фактический объем нормы внесения на площадь',
		'ISOBUS.DDI.20': 'Максимальная норма внесения',
		'ISOBUS.DDI.200': 'Максимальное значение выходного давления насоса',
		'ISOBUS.DDI.201': 'Установка давления перемешивания в резервуаре',
		'ISOBUS.DDI.202': 'Фактическое значение давления перемешивания в резервуаре',
		'ISOBUS.DDI.203': 'Минимальное давления перемешивания в резервуаре',
		'ISOBUS.DDI.204': 'Максимальное давление перемешивания в резервуаре',
		'ISOBUS.DDI.205': 'Время включения управления секциями',
		'ISOBUS.DDI.206': 'Время выключения управления секциями',
		'ISOBUS.DDI.207': 'Скорость ветра',
		'ISOBUS.DDI.208': 'Направление ветра',
		'ISOBUS.DDI.209': 'Относительная влажность',
		'ISOBUS.DDI.21': 'Заданное значение объема на объем нормы внесения',
		'ISOBUS.DDI.210': 'Степень покрытия неба',
		'ISOBUS.DDI.211': 'Количество ходов уплотнения последнего тюка',
		'ISOBUS.DDI.212': 'Средняя влажность последнего тюка',
		'ISOBUS.DDI.213': 'Количество ходов гофрирования за один ход уплотнения последнего тюка',
		'ISOBUS.DDI.214': 'Счетчик тюков за весь период',
		'ISOBUS.DDI.215': 'Часы работы за весь срок службы',
		'ISOBUS.DDI.216': 'Фактическое гидравлическое давление тюка',
		'ISOBUS.DDI.217': 'Последнее среднее гидравлическое давление тюка',
		'ISOBUS.DDI.218': 'Установленная нагрузка на плунжер сжатия тюка',
		'ISOBUS.DDI.219': 'Фактическое значение нагрузки на плунжер сжатия тюка',
		'ISOBUS.DDI.22': 'Фактический объем на объемную норму внесения',
		'ISOBUS.DDI.220': 'Последняя средняя нагрузка на плунжер сжатия тюка',
		'ISOBUS.DDI.221': 'Последний тюк внесенного консерванта',
		'ISOBUS.DDI.222': 'Номер бирки последнего тюка',
		'ISOBUS.DDI.223': 'Масса последнего тюка',
		'ISOBUS.DDI.224': 'Дельта Т',
		'ISOBUS.DDI.225': 'Заданная рабочая длина',
		'ISOBUS.DDI.226': 'Фактическая рабочая длина',
		'ISOBUS.DDI.227': 'Минимальная рабочая длина',
		'ISOBUS.DDI.228': 'Максимальная рабочая длина',
		'ISOBUS.DDI.229': 'Фактический вес нетто',
		'ISOBUS.DDI.23': 'Объем по умолчанию на объем нормы внесения',
		'ISOBUS.DDI.230': 'Состояние веса нетто',
		'ISOBUS.DDI.231': 'Установленный вес нетто',
		'ISOBUS.DDI.232': 'Фактический вес брутто',
		'ISOBUS.DDI.233': 'Состояние веса брутто',
		'ISOBUS.DDI.234': 'Минимальный вес брутто',
		'ISOBUS.DDI.235': 'Максимальный вес брутто',
		'ISOBUS.DDI.236': 'Общее время с молотилкой',
		'ISOBUS.DDI.237': 'Фактическое состояние рабочей высоты жатки',
		'ISOBUS.DDI.238': 'Actual Header Rotational Speed Status',
		'ISOBUS.DDI.239': 'Статус удержания урожая',
		'ISOBUS.DDI.24': 'Минимальный объем на объем нормы внесения',
		'ISOBUS.DDI.240': 'Фактическое состояние системы загрузки(разгрузки)',
		'ISOBUS.DDI.241': 'Температура урожая',
		'ISOBUS.DDI.242': 'Установленный зазор сита',
		'ISOBUS.DDI.243': 'Фактический зазор сита',
		'ISOBUS.DDI.244': 'Минимальное значение зазора сита',
		'ISOBUS.DDI.245': 'Максимальное значение зазора сита',
		'ISOBUS.DDI.246': 'Установленное расстояние секций',
		'ISOBUS.DDI.247': 'Фактическое расстояние секций',
		'ISOBUS.DDI.248': 'Минимальное расстояние секций',
		'ISOBUS.DDI.249': 'Максимальное расстояние секций',
		'ISOBUS.DDI.25': 'Максимальный объем на объем нормы внесения',
		'ISOBUS.DDI.250': 'Заданное значение зазора подбарабанья',
		'ISOBUS.DDI.251': 'Фактическое значение зазора подбарабанья',
		'ISOBUS.DDI.252': 'Минимальный зазор подбарабанья',
		'ISOBUS.DDI.253': 'Максимальное значение зазора подбарабанья',
		'ISOBUS.DDI.254': 'Заданная скорость вращения вентилятора отделения',
		'ISOBUS.DDI.255': 'Фактическая скорость вращения вентилятора отделения',
		'ISOBUS.DDI.256': 'Минимальная скорость вращения вентилятора отделения',
		'ISOBUS.DDI.257': 'Максимальное значение скорости вращения вентилятора разделения',
		'ISOBUS.DDI.258': 'Температура гидравлического масла',
		'ISOBUS.DDI.259': 'Время игнорирования получения данных по урожайности',
		'ISOBUS.DDI.26': 'Заданное значение массы на массовую норму внесения',
		'ISOBUS.DDI.260': 'Время игнорирования опережения урожая',
		'ISOBUS.DDI.261': 'Средняя масса урожая за время',
		'ISOBUS.DDI.262': 'Средняя влажность урожая',
		'ISOBUS.DDI.263': 'Средняя масса урожая с площади',
		'ISOBUS.DDI.264': 'Соединитель Pivot X-Offset',
		'ISOBUS.DDI.265': 'Оставшаяся площадь',
		'ISOBUS.DDI.266': 'Общая масса внесения за весь срок службы',
		'ISOBUS.DDI.267': 'Общее количество внесений за весь срок службы',
		'ISOBUS.DDI.268': 'Общий объем урожая за весь период',
		'ISOBUS.DDI.269': 'Общая масса урожая за весь период',
		'ISOBUS.DDI.27': 'Фактическая массовая норма внесения',
		'ISOBUS.DDI.270': 'Общее количество урожая за весь период',
		'ISOBUS.DDI.271': 'Общая площадь за весь период',
		'ISOBUS.DDI.272': 'Эффективное общее расстояние за весь период',
		'ISOBUS.DDI.273': 'Неэффективное общее расстояние за весь период',
		'ISOBUS.DDI.274': 'Эффективное общее время за весь период',
		'ISOBUS.DDI.275': 'Неэффективное общее время за весть период',
		'ISOBUS.DDI.276': 'Расход топлива за весь период',
		'ISOBUS.DDI.277': 'Средний расход топлива за весь период',
		'ISOBUS.DDI.278': 'Средний расход топлива на площадь за весь период',
		'ISOBUS.DDI.279': 'Общая сухая масса урожая за весь период',
		'ISOBUS.DDI.28': 'Норма массового внесения по умолчанию',
		'ISOBUS.DDI.280': 'Общая масса семян хлопка за весь период',
		'ISOBUS.DDI.281': 'Общая масса хлопка за весь период',
		'ISOBUS.DDI.282': 'Общее время выполнения обмолота за весь период',
		'ISOBUS.DDI.283': 'Общее количество предварительно разрезанных материалов',
		'ISOBUS.DDI.284': 'Общее количество неразрезанных материалов',
		'ISOBUS.DDI.285': 'Общее количество предварительных нарезок за весь период',
		'ISOBUS.DDI.286': 'Общее количество неразрезанных материалов за весь период',
		'ISOBUS.DDI.287': 'Заданное значение режима предписания',
		'ISOBUS.DDI.288': 'Фактическое значение режима предписания',
		'ISOBUS.DDI.289': 'Заданное значение рабочего состояния',
		'ISOBUS.DDI.29': 'Минимальная массовая норма внесения',
		'ISOBUS.DDI.290': 'Заданное рабочее положение секций с 1 по 16',
		'ISOBUS.DDI.291': 'Заданное рабочее положение секций с 17 по 32',
		'ISOBUS.DDI.292': 'Заданное рабочее положение секций с 33 по 48',
		'ISOBUS.DDI.293': 'Заданное рабочее положение секций с 49 по 64',
		'ISOBUS.DDI.294': 'Заданное рабочее положение секций с 65 по 80',
		'ISOBUS.DDI.295': 'Заданное рабочее положение секций с 81 по 96',
		'ISOBUS.DDI.296': 'Заданное рабочее положение секций с 97 по 112',
		'ISOBUS.DDI.297': 'Заданное рабочее положение секций с 113 по 128',
		'ISOBUS.DDI.298': 'Заданное рабочее положение секций с 129 по 144',
		'ISOBUS.DDI.299': 'Заданное рабочее положение секций с 145 по 160',
		'ISOBUS.DDI.3': 'Объем по умолчанию на норму внесения',
		'ISOBUS.DDI.30': 'Максимальная массовая норма внесения',
		'ISOBUS.DDI.300': 'Заданное рабочее положение секций с 161 по 176',
		'ISOBUS.DDI.301': 'Заданное рабочее положение секций с 177 по 192',
		'ISOBUS.DDI.302': 'Заданное рабочее положение секций с 193 по 208',
		'ISOBUS.DDI.303': 'Заданное рабочее положение секций с 209 по 224',
		'ISOBUS.DDI.304': 'Заданное рабочее положение секций с 225 по 240',
		'ISOBUS.DDI.305': 'Заданное рабочее положение секций с 241 по 256',
		'ISOBUS.DDI.306': 'Истинное смещение точки вращения по оси X',
		'ISOBUS.DDI.307': 'Истинное смещение точки вращения по оси Y',
		'ISOBUS.DDI.308': 'Фактическая процентная норма внесения',
		'ISOBUS.DDI.309': 'Минимальная процентная норма внесения',
		'ISOBUS.DDI.31': 'Установленный объем на массовую норму внесения',
		'ISOBUS.DDI.310': 'Максимальная процентная норма внесения',
		'ISOBUS.DDI.311': 'Относительный потенциал доходности',
		'ISOBUS.DDI.312': 'Минимальная относительная доходность',
		'ISOBUS.DDI.313': 'Максимальная относительная урожайность',
		'ISOBUS.DDI.314': 'Фактическое процентное содержание сухого вещества ',
		'ISOBUS.DDI.315': 'Среднее процентное содержание сухого вещества',
		'ISOBUS.DDI.316': 'Эффективный общий расход топлива',
		'ISOBUS.DDI.317': 'Неэффективный общий расход топлива',
		'ISOBUS.DDI.318': 'Эффективный общий расход дизельной выхлопной жидкости',
		'ISOBUS.DDI.319': 'Неэффективный общий расход дизельной выхлопной жидкости',
		'ISOBUS.DDI.32': 'Фактический объем на массовую норму внесения',
		'ISOBUS.DDI.320': 'Вес последней загрузки',
		'ISOBUS.DDI.321': 'Последний выгруженный вес',
		'ISOBUS.DDI.322': 'Загрузить идентификационный номер',
		'ISOBUS.DDI.323': 'Выгрузить идентификационный номер',
		'ISOBUS.DDI.324': 'Общее время включения измельчителя',
		'ISOBUS.DDI.325': 'Общий объем внесения за весь период',
		'ISOBUS.DDI.326': 'Заданная частота вращения',
		'ISOBUS.DDI.327': 'Актуальная частота вращения',
		'ISOBUS.DDI.328': 'Минимальная частота вращения',
		'ISOBUS.DDI.329': 'Максимальная частота вращения',
		'ISOBUS.DDI.33': 'Объем по умолчанию на массовую норму внесения',
		'ISOBUS.DDI.330': 'Заданное значение cкорости режущего барабана',
		'ISOBUS.DDI.331': 'Фактическое значение скорости режущего барабана',
		'ISOBUS.DDI.332': 'Минимальное значение скорости режущего барабана',
		'ISOBUS.DDI.333': 'Максимальное значение скорость режущего барабана',
		'ISOBUS.DDI.334': 'Часы работы с момента последней заточки',
		'ISOBUS.DDI.335': 'Передний ВОМ часы',
		'ISOBUS.DDI.336': 'Задний ВОМ часы',
		'ISOBUS.DDI.337': 'Часы работы переднего ВОМ за весь период',
		'ISOBUS.DDI.338': 'Часы работы заднего ВОМ за весь период',
		'ISOBUS.DDI.339': 'Эффективное общее время загрузки',
		'ISOBUS.DDI.34': 'Минимальный объем на массовую норму внесения',
		'ISOBUS.DDI.340': 'Эффективное общее время разгрузки',
		'ISOBUS.DDI.341': 'Заданный зазор барабанов дробилки зерна в измельчителе',
		'ISOBUS.DDI.342': 'Фактический зазор барабанов дробилки зерна в измельчителе',
		'ISOBUS.DDI.343': 'Минимальный зазор барабанов дробилки зерна в измельчителе',
		'ISOBUS.DDI.344': 'Максимальный зазор барабанов дробилки зерна в измельчителе',
		'ISOBUS.DDI.345': 'Заданная ширина валкования',
		'ISOBUS.DDI.346': 'Фактическая ширина валкования',
		'ISOBUS.DDI.347': 'Минимальная ширина валкования',
		'ISOBUS.DDI.348': 'Максимальная ширина валкования',
		'ISOBUS.DDI.349': 'Снижение сноса сопла',
		'ISOBUS.DDI.35': 'Максимальный объем на массовую норму внесения',
		'ISOBUS.DDI.350': 'Функция или техника работы',
		'ISOBUS.DDI.351': 'Общий объем внесения',
		'ISOBUS.DDI.352': 'Общая масса внесения',
		'ISOBUS.DDI.353': 'Общее внесение азота',
		'ISOBUS.DDI.354': 'Общее внесение аммония',
		'ISOBUS.DDI.355': 'Общее внесение фосфора',
		'ISOBUS.DDI.356': 'Общий объем внесения калия',
		'ISOBUS.DDI.357': 'Общее внесение сухого вещества',
		'ISOBUS.DDI.358': 'Средняя сухая масса за время',
		'ISOBUS.DDI.359': 'Средняя сухая масса на площадь',
		'ISOBUS.DDI.36': 'Заданное значение объема за время нормы внесения',
		'ISOBUS.DDI.360': 'Размер последнего тюка',
		'ISOBUS.DDI.361': 'Плотность последнего тюка',
		'ISOBUS.DDI.362': 'Общая длина тюка',
		'ISOBUS.DDI.363': 'Сухая масса последнего тюка',
		'ISOBUS.DDI.364': 'Фактический размер неполного тюка',
		'ISOBUS.DDI.365': 'Установленное давление прижимной силы',
		'ISOBUS.DDI.366': 'Фактическое давление прижимной силы',
		'ISOBUS.DDI.367': 'Состояние блокировки рабочего положения единиц 1-16',
		'ISOBUS.DDI.368': 'Состояние блокировки рабочего положения единиц 17-32',
		'ISOBUS.DDI.369': 'Состояние блокировки рабочего положения единиц 33-48',
		'ISOBUS.DDI.37': 'Фактический объем за время нормы внесения',
		'ISOBUS.DDI.370': 'Состояние блокировки рабочего положения единиц 49-64',
		'ISOBUS.DDI.371': 'Состояние блокировки рабочего положения единиц 65-80',
		'ISOBUS.DDI.372': 'Состояние блокировки рабочего положения единиц 81-96',
		'ISOBUS.DDI.373': 'Состояние блокировки рабочего положения единиц 97-112',
		'ISOBUS.DDI.374': 'Состояние блокировки рабочего положения единиц 113-128',
		'ISOBUS.DDI.375': 'Состояние блокировки рабочего положения единиц 129-144',
		'ISOBUS.DDI.376': 'Состояние блокировки рабочего положения единиц 145-160',
		'ISOBUS.DDI.377': 'Состояние блокировки рабочего положения единиц 161-176',
		'ISOBUS.DDI.378': 'Состояние блокировки рабочего положения единиц 177-192',
		'ISOBUS.DDI.379': 'Состояние блокировки рабочего положения единиц 193-208',
		'ISOBUS.DDI.38': 'Объем по умолчанию за время нормы внесения',
		'ISOBUS.DDI.380': 'Состояние блокировки рабочего положения единиц 209-224',
		'ISOBUS.DDI.381': 'Состояние блокировки рабочего положения единиц 225-240',
		'ISOBUS.DDI.382': 'Состояние блокировки рабочего положения единиц 241-256',
		'ISOBUS.DDI.383': 'Видимое направление ветра',
		'ISOBUS.DDI.384': 'Видимая скорость ветра',
		'ISOBUS.DDI.385': 'MSL атмосферное давление',
		'ISOBUS.DDI.386': 'Фактическое атмосферное давление',
		'ISOBUS.DDI.387': 'Всего оборотов в дробных оборотах',
		'ISOBUS.DDI.388': 'Всего оборотов в полных оборотах',
		'ISOBUS.DDI.389': 'Заданные обороты указаны как количество за раз',
		'ISOBUS.DDI.39': 'Минимальный объем за время нормы внесения',
		'ISOBUS.DDI.390': 'Фактические обороты за время',
		'ISOBUS.DDI.391': 'Число оборотов по умолчанию за время',
		'ISOBUS.DDI.392': 'Минимальные обороты за время',
		'ISOBUS.DDI.393': 'Максимальные обороты за время',
		'ISOBUS.DDI.394': 'Фактическое содержание топливного бака',
		'ISOBUS.DDI.395': 'Фактическое содержание в баке для отработанной жидкости дизельного двигателя',
		'ISOBUS.DDI.396': 'Заданная скорость',
		'ISOBUS.DDI.397': 'Фактическая скорость',
		'ISOBUS.DDI.398': 'Минимальная скорость',
		'ISOBUS.DDI.399': 'Максимальная скорость',
		'ISOBUS.DDI.4': 'Минимальный объем нормы внесения на площадь',
		'ISOBUS.DDI.40': 'Максимальный объем нормы внесения на площадь',
		'ISOBUS.DDI.400': 'Источник скорости',
		'ISOBUS.DDI.401': 'Фактическое внесение азота',
		'ISOBUS.DDI.402': 'Фактическое внесение аммония',
		'ISOBUS.DDI.403': 'Фактическое применение фосфора',
		'ISOBUS.DDI.404': 'Фактическое внесение калия',
		'ISOBUS.DDI.405': 'Фактическое внесение сухого вещества',
		'ISOBUS.DDI.406': 'Фактическое содержание протеина',
		'ISOBUS.DDI.407': 'Среднее содержание протеина',
		'ISOBUS.DDI.408': 'Среднее загрязнение посевов',
		'ISOBUS.DDI.409': 'Общий расход дизельной выхлопной жидкости',
		'ISOBUS.DDI.41': 'Заданное значение массы за время нормы внесения',
		'ISOBUS.DDI.410': 'Мгновенный расход дизельной выхлопной жидкости за время',
		'ISOBUS.DDI.411': 'Мгновенный расход дизельной выхлопной жидкости на площадь',
		'ISOBUS.DDI.412': 'Потребление выхлопной жидкости дизельного двигателя в течение всего срока службы',
		'ISOBUS.DDI.413': 'Средний расход дизельной выхлопной жидкости на время в течение всего срока службы',
		'ISOBUS.DDI.414': 'Средний расход дизельной выхлопной жидкости на площадь в течение всего срока службы',
		'ISOBUS.DDI.415': 'Фактический процент разделения семян',
		'ISOBUS.DDI.416': 'Средний процент выделения семян',
		'ISOBUS.DDI.417': 'Фактический процент пропуска семян',
		'ISOBUS.DDI.418': 'Средний процент пропуска семян',
		'ISOBUS.DDI.419': 'Фактическое количество семян в процентах',
		'ISOBUS.DDI.42': 'Фактическая массовая норма внесения за время',
		'ISOBUS.DDI.420': 'Средний процент посевного материала',
		'ISOBUS.DDI.421': 'Фактическое отклонение расстояния между семенами',
		'ISOBUS.DDI.422': 'Среднее отклонение расстояния между семенами',
		'ISOBUS.DDI.423': 'Фактический коэффициент вариации процентного расстояния между семенами',
		'ISOBUS.DDI.424': 'Средний коэффициент вариации процентного расстояния между семенами',
		'ISOBUS.DDI.425': 'Заданное значение максимально допустимого отклонения расстояния между семенами',
		'ISOBUS.DDI.426': 'Заданная прижимная сила как сила',
		'ISOBUS.DDI.427': 'Фактическая прижимная сила как сила',
		'ISOBUS.DDI.428': 'Загруженная полная масса',
		'ISOBUS.DDI.429': 'Выгруженная полная масса',
		'ISOBUS.DDI.43': 'Норма внесения массы на время по умолчанию',
		'ISOBUS.DDI.430': 'Общая загруженная масса за весь период',
		'ISOBUS.DDI.431': 'Общая выгруженная масса за весь срок службы',
		'ISOBUS.DDI.432': 'Установленное значение расхода азота',
		'ISOBUS.DDI.433': 'Фактическая норма внесения азота',
		'ISOBUS.DDI.434': 'Минимальная норма внесения азота',
		'ISOBUS.DDI.435': 'Максимальная норма внесения азота',
		'ISOBUS.DDI.436': 'Установленная норма внесения аммония',
		'ISOBUS.DDI.437': 'Фактическая норма внесения аммония',
		'ISOBUS.DDI.438': 'Минимальная норма внесения аммония',
		'ISOBUS.DDI.439': 'Максимальная норма внесения аммония',
		'ISOBUS.DDI.44': 'Минимальная масса за время нормы внесения',
		'ISOBUS.DDI.440': 'Установленное значение расхода фосфора',
		'ISOBUS.DDI.441': 'Фактическое значение расхода фосфора',
		'ISOBUS.DDI.442': 'Минимальное значение расхода фосфора',
		'ISOBUS.DDI.443': 'Максимальное значение расхода фосфора',
		'ISOBUS.DDI.444': 'Установленное значение нормы внесения калия',
		'ISOBUS.DDI.445': 'Фактическое значение нормы внесения калия',
		'ISOBUS.DDI.446': 'Минимальное значение нормы внесения калия',
		'ISOBUS.DDI.447': 'Максимальное значение нормы внесения калия',
		'ISOBUS.DDI.448': 'Установленная норма расхода сухого вещества',
		'ISOBUS.DDI.449': 'Фактическая норма расхода сухого вещества',
		'ISOBUS.DDI.45': 'Максимальная масса за время нормы внесения',
		'ISOBUS.DDI.450': 'Минимальная норма расхода сухого вещества',
		'ISOBUS.DDI.451': 'Максимальная норма расхода сухого вещества',
		'ISOBUS.DDI.452': 'Загруженный общий объем',
		'ISOBUS.DDI.453': 'Выгруженный общий объем',
		'ISOBUS.DDI.454': 'Общий объем загрузки за весь период',
		'ISOBUS.DDI.455': 'Общий объем выгрузки за весь срок службы',
		'ISOBUS.DDI.456': 'Последний загруженный объем',
		'ISOBUS.DDI.457': 'Последний выгруженный объем',
		'ISOBUS.DDI.458': 'Общее количество загрузки',
		'ISOBUS.DDI.459': 'Общее количество выгрузки',
		'ISOBUS.DDI.46': 'Количество заданных значений на время нормы внесения',
		'ISOBUS.DDI.460': 'Общее количество загрузки за весь срок службы',
		'ISOBUS.DDI.461': 'Общее количество выгрузок за весь период',
		'ISOBUS.DDI.462': 'Последний загруженный счетчик',
		'ISOBUS.DDI.463': 'Последний выгруженный счетчик',
		'ISOBUS.DDI.464': 'Счетчик перетаскивания',
		'ISOBUS.DDI.465': 'Количество циклов за весь срок службы',
		'ISOBUS.DDI.466': 'Фактический относительный угол соединителя',
		'ISOBUS.DDI.467': 'Фактическое содержание в процентах',
		'ISOBUS.DDI.468': 'Почва Снег/Замерзшее состояние',
		'ISOBUS.DDI.469': 'Расчетное состояние воды в почве',
		'ISOBUS.DDI.47': 'Фактическое количество на время нормы внесения',
		'ISOBUS.DDI.470': 'Уплотнение почвы',
		'ISOBUS.DDI.472': 'Заданная длина резки',
		'ISOBUS.DDI.473': 'Минимальная длина резки',
		'ISOBUS.DDI.474': 'Максимальная длина резки',
		'ISOBUS.DDI.475': 'Заданное значение гидравлического давления тюка',
		'ISOBUS.DDI.476': 'Минимальное значение гидравлического давления тюка',
		'ISOBUS.DDI.477': 'Максимальное значение гидравлического давления тюка',
		'ISOBUS.DDI.478': 'Заданный размер неполного тюка',
		'ISOBUS.DDI.479': 'Минимальный размер неполного тюка',
		'ISOBUS.DDI.48': 'Количество по умолчанию на время нормы внесения',
		'ISOBUS.DDI.480': 'Максимальный размер неполного тюка',
		'ISOBUS.DDI.481': 'Количество тюков меньшего размера, которые должны быть включены в один тюк большего размера',
		'ISOBUS.DDI.482': 'Количество тюков меньшего размера, включенных в последний произведенный тюк',
		'ISOBUS.DDI.483': 'Заданная частота вращения двигателя',
		'ISOBUS.DDI.484': 'Фактическая частота вращения двигателя',
		'ISOBUS.DDI.485': 'Минимальная частота вращения двигателя',
		'ISOBUS.DDI.486': 'Максимальная частота вращения двигателя',
		'ISOBUS.DDI.488': 'Процентный уровень в баке для отработанной жидкости дизельного двигателя',
		'ISOBUS.DDI.489': 'Максимальный объем топливного бака для выхлопных газов дизельного двигателя',
		'ISOBUS.DDI.49': 'Минимальное число на время нормы внесения',
		'ISOBUS.DDI.490': 'Максимальный объем топливного бака',
		'ISOBUS.DDI.491': 'Уровень топлива в процентах',
		'ISOBUS.DDI.492': 'Общее количество моточасов',
		'ISOBUS.DDI.493': 'Срок службы двигателя, часы',
		'ISOBUS.DDI.494': 'ID партнера последнего события (1-4)',
		'ISOBUS.DDI.495': 'ID партнера последнего события (5-8)',
		'ISOBUS.DDI.496': 'ID партнера последнего события (9-12)',
		'ISOBUS.DDI.497': 'ID партнера последнего события (13-16)',
		'ISOBUS.DDI.498': 'ID партнера последнего события',
		'ISOBUS.DDI.499': 'ID партнера по последнему событию Идентификационный код производителя',
		'ISOBUS.DDI.5': 'Максимальный объем нормы внесения на площадь',
		'ISOBUS.DDI.50': 'Максимальный счетчик на время нормы внесения',
		'ISOBUS.DDI.500': 'ID партнера последнего события Класс устройства',
		'ISOBUS.DDI.501': 'Установленный крутящий момент двигателя',
		'ISOBUS.DDI.502': 'Фактический крутящий момент двигателя',
		'ISOBUS.DDI.503': 'Минимальный крутящий момент двигателя',
		'ISOBUS.DDI.504': 'Максимальный крутящий момент двигателя',
		'ISOBUS.DDI.505': 'Уровень контроля технологической колеи',
		'ISOBUS.DDI.506': 'Заданный уровень контроля технологической колеи',
		'ISOBUS.DDI.507': 'Порядковый номер технологической колеи',
		'ISOBUS.DDI.508': 'Уникальный идентификатор навигационной опорной линии A-B',
		'ISOBUS.DDI.509': 'Фактический номер трека',
		'ISOBUS.DDI.51': 'Заданная глубина обработки почвы',
		'ISOBUS.DDI.510': 'Номер трека справа',
		'ISOBUS.DDI.511': 'Номер трека слева',
		'ISOBUS.DDI.512': 'Ширина полосы захвата навигационной линии',
		'ISOBUS.DDI.513': 'Отклонение навигационной линии',
		'ISOBUS.DDI.514': 'Качество GNSS',
		'ISOBUS.DDI.515': 'Состояние контроля технологической колеи',
		'ISOBUS.DDI.516': 'Увеличенная норма для рядов, примыкающих к технологической колее',
		'ISOBUS.DDI.517': 'Заданное рабочее положение технологической колеи 1-16',
		'ISOBUS.DDI.518': 'Фактическое рабочее положение технологической колеи 1-16',
		'ISOBUS.DDI.519': 'Время последнего тюка',
		'ISOBUS.DDI.52': 'Фактическая глубина обработки',
		'ISOBUS.DDI.520': 'Фактическая высота навеса',
		'ISOBUS.DDI.521': 'Тип установки GNSS',
		'ISOBUS.DDI.522': 'Учет обмотки тюка',
		'ISOBUS.DDI.523': 'Общее количество сетчатых тюков',
		'ISOBUS.DDI.524': 'Время учета обмотки тюка',
		'ISOBUS.DDI.525': 'Общее количество упакованных тюков',
		'ISOBUS.DDI.526': 'Фактическая температура охлаждающей жидкости',
		'ISOBUS.DDI.528': 'Вместимость последнего тюка',
		'ISOBUS.DDI.529': 'Заданное значение угла поворота опор почвообрабатывающего диска',
		'ISOBUS.DDI.53': 'Глубина обработки по умолчанию',
		'ISOBUS.DDI.530': 'Фактический угол поворота диска почвообрабатывающего диска',
		'ISOBUS.DDI.531': 'Фактическое внесение консерванта на массу урожая',
		'ISOBUS.DDI.532': 'Установленное значение применяемого консерванта на массу урожая',
		'ISOBUS.DDI.533': 'Применяемый консервант по умолчанию на массу урожая',
		'ISOBUS.DDI.534': 'Минимальное количество применяемого консерванта на массу урожая',
		'ISOBUS.DDI.535': 'Максимально применяемый консервант на массу урожая',
		'ISOBUS.DDI.536': 'Всего внесено консерванта',
		'ISOBUS.DDI.537': 'Консервант, внесенный за весь срок ',
		'ISOBUS.DDI.538': 'Среднее количество применяемого консерванта на массу урожая',
		'ISOBUS.DDI.539': 'Фактический объем бака консерванта',
		'ISOBUS.DDI.54': 'Минимальная глубина обработки',
		'ISOBUS.DDI.540': 'Фактический уровень консерванта в баке',
		'ISOBUS.DDI.541': 'Фактическая скорость ВОМ',
		'ISOBUS.DDI.542': 'Заданное значение скорости ВОМ',
		'ISOBUS.DDI.543': 'Скорость ВОМ по умолчанию',
		'ISOBUS.DDI.544': 'Минимальная скорость ВОМ',
		'ISOBUS.DDI.545': 'Максимальная скорость ВОМ',
		'ISOBUS.DDI.546': 'Общее время рубки',
		'ISOBUS.DDI.547': 'Установленная нагрузка на плунжер сжатия тюка',
		'ISOBUS.DDI.548': 'Фактическая нагрузка на плунжер сжатия тюка',
		'ISOBUS.DDI.549': 'Последний тюк средняя нагрузка на плунжер сжатия тюка',
		'ISOBUS.DDI.55': 'Максимальная глубина обработки',
		'ISOBUS.DDI.550': 'Почвопокровное покрытие',
		'ISOBUS.DDI.551': 'Фактический крутящий момент ВОМ',
		'ISOBUS.DDI.552': 'Заданный крутящий момент ВОМ',
		'ISOBUS.DDI.553': 'Крутящий момент ВОМ по умолчанию',
		'ISOBUS.DDI.554': 'Минимальный крутящий момент ВОМ',
		'ISOBUS.DDI.555': 'Максимальный крутящий момент ВОМ',
		'ISOBUS.DDI.556': 'Текущие погодные условия',
		'ISOBUS.DDI.557': 'Заданный электрический ток',
		'ISOBUS.DDI.558': 'Фактический электрический ток',
		'ISOBUS.DDI.559': 'Минимальный электрический ток',
		'ISOBUS.DDI.56': 'Заданная глубина высева',
		'ISOBUS.DDI.560': 'Максимальный электрический ток',
		'ISOBUS.DDI.561': 'Электрический ток по умолчанию',
		'ISOBUS.DDI.562': 'Заданное значение напряжения',
		'ISOBUS.DDI.563': 'Напряжение по умолчанию',
		'ISOBUS.DDI.564': 'Фактическое напряжение',
		'ISOBUS.DDI.565': 'Минимальное напряжение',
		'ISOBUS.DDI.566': 'Максимальное напряжение',
		'ISOBUS.DDI.567': 'Фактическое электрическое сопротивление',
		'ISOBUS.DDI.568': 'Установленная электрическая мощность',
		'ISOBUS.DDI.569': 'Фактическая электрическая мощность',
		'ISOBUS.DDI.57': 'Фактическая глубина высева',
		'ISOBUS.DDI.570': 'Электрическая мощность по умолчанию',
		'ISOBUS.DDI.571': 'Максимальная электрическая мощность',
		'ISOBUS.DDI.572': 'Минимальная электрическая мощность',
		'ISOBUS.DDI.573': 'Общая электрическая энергия',
		'ISOBUS.DDI.574': 'Установленная электрическая энергия на единицу площади нормы внесения',
		'ISOBUS.DDI.575': 'Фактическая электрическая энергия на единицу площади нормы внесения',
		'ISOBUS.DDI.576': 'Максимальная электрическая энергия на площадь нормы внесения',
		'ISOBUS.DDI.577': 'Минимальная электрическая энергия на площадь нормы внесения',
		'ISOBUS.DDI.578': 'Заданная температура',
		'ISOBUS.DDI.579': 'Фактическая температура',
		'ISOBUS.DDI.58': 'Глубина посева по умолчанию',
		'ISOBUS.DDI.580': 'Минимальная температура',
		'ISOBUS.DDI.581': 'Максимальная температура',
		'ISOBUS.DDI.582': 'Температура по умолчанию',
		'ISOBUS.DDI.583': 'Заданная частота',
		'ISOBUS.DDI.584': 'Фактическая частота',
		'ISOBUS.DDI.585': 'Минимальная частота',
		'ISOBUS.DDI.586': 'Максимальная частота',
		'ISOBUS.DDI.587': 'Предыдущий дождь',
		'ISOBUS.DDI.588': 'Заданный объема на единицу площади нормы внесения',
		'ISOBUS.DDI.589': 'Фактический объем нормы внесения на площадь',
		'ISOBUS.DDI.59': 'Минимальная глубина посева',
		'ISOBUS.DDI.590': 'Минимальный объем на площадь нормы внесения',
		'ISOBUS.DDI.591': 'Максимальный объем на площадь нормы внесения',
		'ISOBUS.DDI.592': 'Объем по умолчанию на норму внесения',
		'ISOBUS.DDI.593': 'Тип тяги',
		'ISOBUS.DDI.594': 'Тип рулевого управления',
		'ISOBUS.DDI.595': 'Машинный режим',
		'ISOBUS.DDI.596': 'Состояние крышки грузового отсека',
		'ISOBUS.DDI.597': 'Общее расстояние',
		'ISOBUS.DDI.598': 'Общее расстояния за весь период',
		'ISOBUS.DDI.599': 'Общее расстояние поля',
		'ISOBUS.DDI.6': 'Заданная масса на единицу площади нормы внесения',
		'ISOBUS.DDI.60': 'Максимальная глубина посева',
		'ISOBUS.DDI.600': 'Время общего расстояния поля',
		'ISOBUS.DDI.601': 'Общее расстояние, пройденное по дороге',
		'ISOBUS.DDI.602': 'Общее расстояние, пройденное по улицам за весь срок',
		'ISOBUS.DDI.603': 'Фактическое рабочее состояние технологической колеи (17-32)',
		'ISOBUS.DDI.604': 'Фактическое рабочее состояние технологической колеи (33-48)',
		'ISOBUS.DDI.605': 'Фактическое рабочее состояние технологической колеи (49-64)',
		'ISOBUS.DDI.606': 'Фактическое рабочее состояние технологической колеи (65-80)',
		'ISOBUS.DDI.607': 'Фактическое рабочее состояние технологической колеи (81-96)',
		'ISOBUS.DDI.608': 'Фактическое рабочее состояние технологической колеи (97-112)',
		'ISOBUS.DDI.609': 'Фактическое рабочее состояние технологической колеи (113-128)',
		'ISOBUS.DDI.61': 'Заданная рабочая высота',
		'ISOBUS.DDI.610': 'Фактическое рабочее состояние технологической колеи (129-144)',
		'ISOBUS.DDI.611': 'Фактическое рабочее состояние технологической колеи (145-160)',
		'ISOBUS.DDI.612': 'Фактическое рабочее состояние технологической колеи (161-176)',
		'ISOBUS.DDI.613': 'Фактическое рабочее состояние технологической колеи (177-192)',
		'ISOBUS.DDI.614': 'Фактическое рабочее состояние технологической колеи (193-208)',
		'ISOBUS.DDI.615': 'Фактическое рабочее состояние технологической колеи (209-224)',
		'ISOBUS.DDI.616': 'Фактическое рабочее состояние технологической колеи (225-240)',
		'ISOBUS.DDI.617': 'Фактическое рабочее состояние технологической колеи (241-256)',
		'ISOBUS.DDI.618': 'Установленное рабочее состояние технологической колеи (17-32)',
		'ISOBUS.DDI.619': 'Установленное рабочее состояние технологической колеи (33-48)',
		'ISOBUS.DDI.62': 'Фактическая рабочая высота',
		'ISOBUS.DDI.620': 'Установленное рабочее состояние технологической колеи (49-64)',
		'ISOBUS.DDI.621': 'Установленное рабочее состояние технологической колеи (65-80)',
		'ISOBUS.DDI.622': 'Установленное рабочее состояние технологической колеи (81-96)',
		'ISOBUS.DDI.623': 'Установленное рабочее состояние технологической колеи (97-112)',
		'ISOBUS.DDI.624': 'Установленное рабочее состояние технологической колеи (113-128)',
		'ISOBUS.DDI.625': 'Установленное рабочее состояние технологической колеи (129-144)',
		'ISOBUS.DDI.626': 'Установленное рабочее состояние технологической колеи (145-160)',
		'ISOBUS.DDI.627': 'Установленное рабочее состояние технологической колеи (161-176)',
		'ISOBUS.DDI.628': 'Установленное рабочее состояние технологической колеи (177-192)',
		'ISOBUS.DDI.629': 'Установленное рабочее состояние технологической колеи (193-208)',
		'ISOBUS.DDI.63': 'Рабочая высота по умолчанию',
		'ISOBUS.DDI.630': 'Установленное рабочее состояние технологической колеи (209-224)',
		'ISOBUS.DDI.631': 'Установленное рабочее состояние технологической колеи (225-240)',
		'ISOBUS.DDI.632': 'Установленное рабочее состояние технологической колеи (241-256)',
		'ISOBUS.DDI.634': 'Фактический объем на расстояние Норма внесения',
		'ISOBUS.DDI.635': 'По умолчанию Объем на расстояние Норма внесения',
		'ISOBUS.DDI.636': 'Минимальный объем на расстояние Норма внесения',
		'ISOBUS.DDI.637': 'Максимальный объем на расстояние Норма внесения',
		'ISOBUS.DDI.638': 'Заданное давление в шинах',
		'ISOBUS.DDI.639': 'Фактическое давление в шинах',
		'ISOBUS.DDI.64': 'Минимальная рабочая высота',
		'ISOBUS.DDI.640': 'Давление в шинах по умолчанию',
		'ISOBUS.DDI.641': 'Минимальное давление в шинах',
		'ISOBUS.DDI.642': 'Максимальное давление в шинах',
		'ISOBUS.DDI.643': 'Фактическая температура шины',
		'ISOBUS.DDI.65': 'Максимальная рабочая высота',
		'ISOBUS.DDI.66': 'Заданная рабочая ширина',
		'ISOBUS.DDI.67': 'Фактическая рабочая ширина',
		'ISOBUS.DDI.68': 'Рабочая ширина по умолчанию',
		'ISOBUS.DDI.69': 'Минимальная рабочая ширина',
		'ISOBUS.DDI.7': 'Фактическая масса на единицу площади нормы внесения',
		'ISOBUS.DDI.70': 'Максимальная рабочая ширина',
		'ISOBUS.DDI.71': 'Заданное значение содержания объема',
		'ISOBUS.DDI.72': 'Фактическое значение содержания',
		'ISOBUS.DDI.73': 'Максимальное значение содержания',
		'ISOBUS.DDI.74': 'Заданное значение массового содержания',
		'ISOBUS.DDI.75': 'Фактическое массовое содержание',
		'ISOBUS.DDI.76': 'Максимальное массовое содержание',
		'ISOBUS.DDI.77': 'Заданное значение счетчика содержания',
		'ISOBUS.DDI.78': 'Фактическое значение счетчика содержания',
		'ISOBUS.DDI.79': 'Максимальное значение счетчика содержания',
		'ISOBUS.DDI.8': 'Норма внесения массы по умолчанию на площадь',
		'ISOBUS.DDI.80': 'Общий объем внесения',
		'ISOBUS.DDI.81': 'Общая масса внесения',
		'ISOBUS.DDI.82': 'Общее число внесения',
		'ISOBUS.DDI.83': 'Объем урожайности на площадь',
		'ISOBUS.DDI.84': 'Масса урожайности на площадь',
		'ISOBUS.DDI.85': 'Подсчет на площадь урожая',
		'ISOBUS.DDI.86': 'Объем за время урожая',
		'ISOBUS.DDI.87': 'Выход массы за время',
		'ISOBUS.DDI.88': 'Подсчет за время урожая',
		'ISOBUS.DDI.89': 'Общий объем урожая',
		'ISOBUS.DDI.9': 'Минимальная масса на единицу площади внесения',
		'ISOBUS.DDI.90': 'Общая масса урожая',
		'ISOBUS.DDI.91': 'Общее количество урожая',
		'ISOBUS.DDI.92': 'Объем потерь урожая на площадь',
		'ISOBUS.DDI.93': 'Масса потерь урожая на площадь',
		'ISOBUS.DDI.94': 'Количество потерь урожая на площадь',
		'ISOBUS.DDI.95': 'Объем за время потери урожая',
		'ISOBUS.DDI.96': 'Масса за время потери урожая',
		'ISOBUS.DDI.97': 'Подсчет за время потери урожая',
		'ISOBUS.DDI.98': 'Процент потери урожая',
		'ISOBUS.DDI.99': 'Влажность урожая',
		'ISOBUS.DEVICE_CLASS.0': 'Не указано',
		'ISOBUS.DEVICE_CLASS.1': 'Трактор',
		'ISOBUS.DEVICE_CLASS.10': 'Орошение',
		'ISOBUS.DEVICE_CLASS.11': 'Транспорт/Прицеп',
		'ISOBUS.DEVICE_CLASS.12': 'Операции фермы',
		'ISOBUS.DEVICE_CLASS.13': 'Вспомогательные устройства с питанием',
		'ISOBUS.DEVICE_CLASS.14': 'Особые культуры',
		'ISOBUS.DEVICE_CLASS.15': 'Земляные работы',
		'ISOBUS.DEVICE_CLASS.16': 'Трелёвочный трактор',
		'ISOBUS.DEVICE_CLASS.17': 'Сенсорные системы',
		'ISOBUS.DEVICE_CLASS.18': ' - ',
		'ISOBUS.DEVICE_CLASS.19': 'Лесозаготовительные комбайны',
		'ISOBUS.DEVICE_CLASS.2': 'Обработка почвы',
		'ISOBUS.DEVICE_CLASS.20': 'Экспедиторы',
		'ISOBUS.DEVICE_CLASS.21': 'Лесопогрузчики',
		'ISOBUS.DEVICE_CLASS.22': 'Машины для обработки древесины',
		'ISOBUS.DEVICE_CLASS.23': 'Мульчеры',
		'ISOBUS.DEVICE_CLASS.24': 'Коммунальная техника',
		'ISOBUS.DEVICE_CLASS.25': 'Машины для внесения жидкого навоза/навоза',
		'ISOBUS.DEVICE_CLASS.26': 'Питатели/Смесители',
		'ISOBUS.DEVICE_CLASS.27': 'Культиваторы',
		'ISOBUS.DEVICE_CLASS.3': 'Вторичная обработка почвы',
		'ISOBUS.DEVICE_CLASS.4': 'Сеялки',
		'ISOBUS.DEVICE_CLASS.5': 'Удобрения',
		'ISOBUS.DEVICE_CLASS.6': 'Опрыскиватели',
		'ISOBUS.DEVICE_CLASS.7': 'Комбайны',
		'ISOBUS.DEVICE_CLASS.8': 'Корнеуборочные комбайны',
		'ISOBUS.DEVICE_CLASS.9': 'Корма',
		'JOB.ARCHIVE.QUESTION': 'Вы уверены что хотите заархивировать это задание?',
		'JOB.ARCHIVE.SUCCESS': 'Задание будет заархивировано',
		'JOB.CAN_NOT_BE_DISPLAYED_COMPLETELY': 'Работа не может быть отображена полностью. Любая информация выше может быть устаревшей и будет пересчитана.',
		'JOB.CURRENT_STATUS': 'Текущий статус',
		'JOB.DELETE.QUESTION': 'Вы уверены что хотите удалить это задание?',
		'JOB.DELETE.SUCCESS': 'Задание будет удалено',
		'JOB.DETAILS': 'Детали задания',
		'JOB.DRIVER_IMPLEMENT': 'Удалить или изменить водителя/оборудование.',
		'JOB.EDIT': 'Редактировать работу',
		'JOB.REGENERATE': 'Восстановить задание',
		'JOB.REGENERATE.DRIVER': 'Обновить данные водителя',
		'JOB.REGENERATE.FIELDS': 'Обновление полевых данных',
		'JOB.REGENERATE.IMPLEMENT': 'Обновить данные оборудования',
		'JOB.REGENERATE.INTRO': 'Если данные для выставления счетов за машины, навесное оборудование или драйверы изменились, их также можно обновить.',
		'JOB.REGENERATE.LOCATIONS': 'Обновление данных о местоположении',
		'JOB.REGENERATE.MACHINE': 'Обновление данных машины',
		'JOB.REGENERATE.QUESTION': 'Какие данные нужно обновить?',
		'JOB.REGENERATE.SUCCESS': 'Задание будет восстановлено',
		'JOB.SPLIT': 'Разделить задание',
		'JOB.SPLIT.ADD_SPLIT_TIME': 'Добавить время разделения',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO': 'Для настройки с точностью до секунды ползунок времени можно также использовать с помощью кнопок со стрелками.',
		'JOB.SPLIT.ADD_SPLIT_TIMES_INTRO2': 'Добавьте время(на), чтобы разделить работу.',
		'JOB.SPLIT.NO_CHANGE': 'Задание не изменено',
		'JOB.SPLIT.NO_SPLITS': 'Нет времени(ов), выбранного(ых) для разделения.',
		'JOB.UPDATE': 'Обновить задание (задания)',
		'JOB.WAITING_TIME_UNTIL_READY': 'В зависимости от текущего статуса может потребоваться несколько минут, прежде чем задание станет полностью отображено.',
		'JOBS': 'Работы',
		'JOBS.ALL': 'Все работы',
		'JOBS.ARCHIVE.PARTIAL': 'Некоторые работы заархивированы.',
		'JOBS.ARCHIVE.QUESTION': 'Вы действительно хотите заархивировать выбранные работы?',
		'JOBS.ARCHIVE.SUCCESS': 'Работы будут заархивированы',
		'JOBS.CREATE_TASK': 'Создать задание',
		'JOBS.DELETE.QUESTION': 'Вы действительно хотите удалить выбранные задания? Все данные о рабочих местах будут удалены безвозвратно.',
		'JOBS.DELETE.SUCCESS': 'Рабочие места будут удаляться',
		'JOBS.DELETED.FAILURE': 'Не удалось удалить некоторые работы',
		'JOBS.EDIT': 'Редактировать работы',
		'JOBS.EDIT.SUCCESS': 'Работы будут отредактированы',
		'JOBS.IN_TASK': 'Работы в задачах',
		'JOBS.MERGE.SUCCESS': 'Задания будут объеденены',
		'JOBS.MERGING': 'Объединить работы',
		'JOBS.NO': 'Нет работ',
		'JOBS.NOT_SELECTED': 'Нет выбранных задач',
		'JOBS.REGENERATE': 'Восстановить работы',
		'JOBS.REGENERATE.SUCCESS': 'Работы будут восстановлены',
		'JOBS.SELECTED': 'Выбранные работы',
		'JOBS.TASK_CREATED': 'Задание успешно создано',
		'JOBS.UPDATE.SUCCESS': 'Рабочие места будут обновлены',
		'JOBS.WITHOUT_TASK': 'Работы без задачи',
		'JOBS.WITH_TASK': 'Работы в задаче',
		'KILOMETERS': 'Километры',
		'LANGUAGE': 'Язык',
		'LANGUAGE.ADD': 'Добавить язык',
		'LANGUAGE.CODE': 'Код языка',
		'LANGUAGE.DEFAULT': 'Язык по умолчанию',
		'LASTNAME': 'Фамилия',
		'LAST_ONLINE': 'Последний раз онлайн',
		'LAST_UPDATED': 'Последнее обновление',
		'LATITUDE': 'Широта',
		'LOAD.MORE': 'Загрузить больше',
		'LOADS': 'Нагрузки',
		'LOCATION': 'Место положения',
		'LOCATION.ADD': 'Добавить местоположение',
		'LOCATION.ADD.SUCCESS': 'Местоположение успешно добавлено',
		'LOCATION.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать местоположение?',
		'LOCATION.DEACTIVATE.SUCCESS': 'Местоположение успешно деактивировано',
		'LOCATION.DELETE.QUESTION': 'Вы действительно хотите удалить местоположение?',
		'LOCATION.DELETE.SUCCESS': 'Местоположение успешно удалено',
		'LOCATION.DETAILS': 'Детали местоположения',
		'LOCATION.DRAW.START': 'Отметить местоположение на карте!',
		'LOCATION.EDIT.SUCCESS': 'Местоположение успешно отредактировано',
		'LOCATIONS': 'Местоположения',
		'LOCATIONS.ALL': 'Все местоположения',
		'LOCATIONS.DEACTIVATE.FAILURE': 'Некоторые локации не удалось деактивировать.',
		'LOCATIONS.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать местоположения?',
		'LOCATIONS.DEACTIVATE.SUCCESS': 'Места успешно деактивированы',
		'LOCATIONS.DELETE.FAILURE': 'Не удалось удалить некоторые местоположения',
		'LOCATIONS.DELETE.QUESTION': 'Вы действительно хотите удалить выбранные места?',
		'LOCATIONS.DELETE.SUCCESS': 'Местоположения успешно удалены',
		'LOCATIONS.NO': 'Нет местоположений',
		'LOCATIONS.NOT_SELECTED': 'Нет выбранных местоположений',
		'LOCATIONS.REACTIVATE.FAILURE': 'Некоторые места не удалось восстановить.',
		'LOCATIONS.REACTIVATE.QUESTION': 'Вы действительно хотите активировать выбранные места?',
		'LOCATIONS.REACTIVATE.SUCCESS': 'Локации успешно восстановлены',
		'LOCATIONS.SELECTED': 'Выбранные месторасположения',
		'LOG': 'Журнал сообщений',
		'LOGIN': 'Войти',
		'LOGIN.NOT_UNLOCKED_YET': 'Еще не разблокировано?',
		'LOGIN.NO_ACCOUNT_YET': 'Еще нет аккаунта?',
		'LOGIN.PASSWORD_FORGOTTEN': 'Забыли пароль?',
		'LOGIN.REGISTER': 'Зарегистрироваться',
		'LOGIN.REMEMBER_PASSWORD': 'Напомнить пароль',
		'LOGIN.UNLOCK': 'Разблокировать',
		'LOG_OUT': 'Выйти',
		'LONGITUDE': 'Долгота',
		'LOST_PASSWORD.CHANGE_PASSWORD': 'Изменить пароль',
		'LOST_PASSWORD.ENTER_ACTIVATION': 'Пожалуйста, введите код активации, который вы получили по электронной почте..',
		'LOST_PASSWORD.ENTER_EMAIL_HERE': 'Пожалуйста, введите здесь свой адрес электронной почты.',
		'LOST_PASSWORD.ENTER_VALID_EMAIL': 'Пожалуйста, введите действительный адрес электронной почты.',
		'MAC': 'MAC',
		'MACHINE': 'Машина',
		'MACHINE.ADD': 'Добавить машину',
		'MACHINE.ADD.SUCCESS': 'Машина добавлена',
		'MACHINE.DELETE.QUESTION': 'Вы действительно хотите удалить машину?',
		'MACHINE.DELETE.SUCCESS': 'Машина успешно удалена',
		'MACHINE.DETAILS': 'Детали машины',
		'MACHINE.EDIT': 'Редактировать машину',
		'MACHINE.EDIT.SUCCESS': 'Машина успешно отредактирована',
		'MACHINE.INTERVAL.ADD': 'Добавить машинный интервал',
		'MACHINE.LIVE_STATUS': 'Статус машины',
		'MACHINE.NO': 'Нет машины',
		'MACHINE.RELOAD_POSITIONS': 'Перезагрузите позиции машины',
		'MACHINE.STATUS': 'Состояние машины',
		'MACHINES': 'Машины',
		'MACHINES.ALL': 'Все машины',
		'MACHINES.DEACTIVATE.FAILURE': 'Некоторые машины невозможно было деактивировать.',
		'MACHINES.DEACTIVATE.QUESTION': 'Вы действительно хотите деактивировать выбранные машины?',
		'MACHINES.DEACTIVATE.SUCCESS': 'Машины успешно деактивированы',
		'MACHINES.DELETE.FAILURE': 'Некоторые машины не могут быть удалены',
		'MACHINES.DELETE.QUESTION': 'Вы действительно хотите удалить выбранные машины?',
		'MACHINES.DELETE.SUCCESS': 'Машины успешно удалены',
		'MACHINES.MANAGEMENT': 'Управление машинами',
		'MACHINES.NO': 'Нет машин',
		'MACHINES.NOT_SELECTED': 'Нет выбранных машин',
		'MACHINES.NO_LICENSE.WARNING': 'Машина не имеет прилагаемой лицензии. Без лицензии данные не записываются.',
		'MACHINES.REACTIVATE.FAILURE': 'Некоторые машины не удалось активировать.',
		'MACHINES.REACTIVATE.QUESTION': 'Вы действительно хотите активировать выбранные машины?',
		'MACHINES.REACTIVATE.SUCCESS': 'Машины активированы успешно',
		'MACHINES.SELECTED': 'Выбранные машины',
		'MACHINE_COMBINATION': 'Machine combination',
		'MACHINE_IMPLEMENT': 'Машина/оборудование',
		'MAC_DEVICES': 'Устройства, подключенные к машине',
		'MAINTENANCE': 'Техническое обслуживание',
		'MAINTENANCE.AMOUNT': 'Сумма обслуживания',
		'MAINTENANCE.PERIOD': 'Период обслуживания',
		'MAKE': 'Делать',
		'MANURE': 'Навоз',
		'MANURE.TYPE': 'Тип навоза',
		'MAP': 'Карта',
		'MAP.SECTION': 'Раздел карты',
		'MAP.SECTION.CHANGE': 'Изменить раздел карты',
		'MARKER.ADD': 'Добавить новый маркер',
		'MARKER.EDIT.BORDERS': 'Редактировать границы',
		'MARKER.ENTRANCE': 'Вход',
		'MARKER.EXIT': 'Выход',
		'MARKER.INFO': 'Информация',
		'MARKER.WARN': 'Предупреждать',
		'MAX': 'Макс',
		'MAX_VALUE': 'Максимальное значение',
		'MERGE': 'Объединить',
		'MESSAGES.NO': 'Нет сообщений',
		'MILEAGE': 'Пробег',
		'MILEAGE.INVALID': 'Неверный пробег',
		'MIN': 'Мин',
		'MIN_VALUE': 'Минимальное значение',
		'MOBILE': 'Мобильный',
		'MODE.SWITCH': 'Переключить режим',
		'MODEL': 'Модель',
		'MYPROFILE': 'Мой профиль',
		'MYPROFILE.BASIC_DATA': 'Основные данные',
		'MYPROFILE.BASIC_DATA.EDIT.SUCCESS': 'Ваши основные данные были изменены.',
		'NAME': 'Имя',
		'NAV.ACTIVITIES': 'Мероприятия',
		'NAV.ADMIN': 'Администратор',
		'NAV.ADMIN.DASHBOARD': 'Приборная панель',
		'NAV.ADMIN.INFO_VIEW': 'Admin Info',
		'NAV.ADMIN.JOB_IMPORT_VIEW': 'Job import',
		'NAV.ADMIN.JOB_VIEW': 'Просмотр вакансий',
		'NAV.ADMIN.USERS': 'Управление пользователями',
		'NAV.CUSTOMERS': 'Пользователи',
		'NAV.DASHBOARD': 'Приборная панель',
		'NAV.DATA_PREPARATION': 'Подготовка данных',
		'NAV.EMPLOYEES': 'Сотрудники',
		'NAV.ENTERPRISE': 'Компания',
		'NAV.FIELDS': 'Поля',
		'NAV.FILE_TRANSFER': 'ISO Taskdata',
		'NAV.HARDWARE': 'Аппаратное обеспечение',
		'NAV.HARDWARE_SETUP': 'Настройка оборудования',
		'NAV.IMPLEMENTS': 'Оборудование',
		'NAV.LOCATIONS': 'Местоположения',
		'NAV.MACHINES': 'Машины',
		'NAV.MY_SECTION': 'Мой раздел',
		'NAV.PATH_PLANNINGS': 'Path planning',
		'NAV.RETAILER': 'Партнер',
		'NAV.SETTINGS': 'Настройки',
		'NAV.SETTINGS.ADAPTER': 'Адаптер',
		'NAV.SETTINGS.GENERAL': 'Компания',
		'NAV.SETTINGS.PARTNER': 'Партнер',
		'NAV.STATISTIC': 'Статистика',
		'NAV.TECH': 'TECH',
		'NAV.TRANSLATION.EDIT': 'Исправить перевод',
		'NAV.TRANSLATION_MANAGEMENT': 'Управление переводом',
		'NETWORK.ACCESS_TECHNOLOGY': 'Технология доступа',
		'NETWORK.OPERATOR': 'Оператор',
		'NEXT': 'Следующий',
		'NO': 'Нет',
		'NONE': 'Нет',
		'NOTICE': 'Примечание',
		'NON_PRODUCTIVE_TIME': 'Непроизводительное время',
		'NON_PRODUCTIVE_TIMES': 'Непроизводительное время',
		'NON_PRODUCTIVE_TIMES.SEPARATOR': 'Separator for non productive time computation',
		'NOT_READ': 'Не читается.',
		'NO_DATA': 'Нет данных',
		'ONLY_ON': 'Только на',
		'OPACITY': 'Затененность',
		'OPERATING_HOURS': 'Часы работы',
		'OPERATING_HOURS.INVALID': 'Часы работы недействительны',
		'OPERATION': 'Операция',
		'OPERATION.NOT_SELECTED': 'Нет выбранных операций на поле',
		'OPERATION.SELECT': 'Выбрать операцию',
		'OPERATIONS': 'Операции',
		'OPERATIONS.ARRIVAL': 'Прибытие',
		'OPERATIONS.CUSTOMER': 'Операции для клиента',
		'OPERATIONS.FIELD': 'Операции на поле',
		'OPERATIONS.FIELDS': 'Операции на полях',
		'OPERATIONS.FIELD_TIME': 'Время на поле',
		'OPERATIONS.GEOMETRY': 'Геометрия',
		'OPERATIONS.LOCATION': 'Операции в местоположении',
		'OPERATIONS.LOCATIONS': 'Операции в местоположениях',
		'OPERATIONS.NO': 'Нет операций',
		'OPERATIONS.PREPARATION': 'Подготовка',
		'OVERRIDE.NO': 'Без переопределения',
		'PAGE': 'Page',
		'PAGE.OF': 'of',
		'PAGINATION.PER_PAGE': 'На страницу',
		'PAGINATION.TOTAL': 'всего',
		'PAGINATOR.FIRST_PAGE': 'Первая страница',
		'PAGINATOR.ITEMS_PER_PAGE': 'Элементы на странице',
		'PAGINATOR.LAST_PAGE': 'Последняя страница',
		'PAGINATOR.NEXT_PAGE': 'Следующая страница',
		'PAGINATOR.OF': 'из',
		'PAGINATOR.PREVIOUS_PAGE': 'Предыдущая страница',
		'PARTNER_CONNECTION': 'Партнёрская связь',
		'PARTNER_CONNECTION.DOES_NOT_EXPIRE': 'Не истекает',
		'PARTNER_CONNECTION.EXPIRES_ON': 'Истекает',
		'PASSWORD': 'Пароль',
		'PASSWORD.CHANGE': 'Смена пароля',
		'PASSWORD.CHANGE.ACTIVATE': 'Текущий пароль',
		'PASSWORD.CHANGE.SUCCESS': 'Пароль успешно изменён',
		'PASSWORD.CONFIRM': 'Подтвердите новый пароль',
		'PASSWORD.LENGTH.REQUIRED': 'Пароль должен быть не менее 6 символов',
		'PASSWORD.NEW_PASSWORD': 'Новый пароль',
		'PASSWORD.NO_MATCH': 'Несоответствие подтверждения пароля!',
		'PATH_PLANNING.ADD': 'Plan path',
		'PATH_PLANNING.ADD.SUCCESS': 'Planned path successfully added',
		'PATH_PLANNING.ANGLE': 'Angle',
		'PATH_PLANNING.ANGLE.LONGEST_SIDE': 'Longest side',
		'PATH_PLANNING.ANGLE.OPTIMAL': 'Optimal',
		'PATH_PLANNING.ANGLE.WORKING': 'Working angle',
		'PATH_PLANNING.AREA.COVERED': 'Covered area',
		'PATH_PLANNING.AREA.OVERLAP': 'Overlapped area',
		'PATH_PLANNING.AREA.UNCOVERED': 'Uncovered area',
		'PATH_PLANNING.DETAILS': 'Planned path',
		'PATH_PLANNING.GENERATE_PATH': 'Generate path',
		'PATH_PLANNING.GEOMETRY.CHANGED.QUESTION': 'The field boundary has been changed. Do you want to store the boundary as the current boundary of the field?',
		'PATH_PLANNING.NAME': 'Path planning name',
		'PATH_PLANNING.NAME.EXPLANATION': 'Give the path planning a name',
		'PATH_PLANNING.NOT_ENOUGH_DATA_EXPECTATION': 'Currently there is not enough data to compute the expected fuel consumption, CO2 consumption and cost',
		'PATH_PLANNING.SELECT.FIELD': 'Select the field you want the path to be planned for',
		'PATH_PLANNING.SEND_TO_MACHINE': 'Send to machine',
		'PATH_PLANNING.SETTINGS.CHANGED.QUESTION': 'The settings have been changed after generating the currently shown planned path and will not be reflected when saved. Do you want to continue?',
		'PATH_PLANNING.SUBDIVIDE': 'Subdivide field',
		'PATH_PLANNINGS.DEACTIVATE.FAILURE': 'Some of the planned paths could not be deactivated',
		'PATH_PLANNINGS.DEACTIVATE.QUESTION': 'Do you really want to deactivate the planned path?',
		'PATH_PLANNINGS.DEACTIVATE.SUCCESS': 'Planned paths have been deactivated',
		'PATH_PLANNINGS.DELETE.FAILURE': 'Some of the planned paths could not be deleted',
		'PATH_PLANNINGS.DELETE.QUESTION': 'Do you really want to delete the planned path?',
		'PATH_PLANNINGS.DELETE.SUCCESS': 'Planned paths deleted successfully',
		'PATH_PLANNINGS.MANAGEMENT': 'Planned paths management',
		'PATH_PLANNINGS.NOT_SELECTED': 'No planned path selected',
		'PATH_PLANNINGS.REACTIVATE.FAILURE': 'Some of the planned paths could not be reactivated',
		'PATH_PLANNINGS.REACTIVATE.QUESTION': 'Do you really want to reactivate the selected planned paths?',
		'PATH_PLANNINGS.REACTIVATE.SUCCESS': 'Planned paths reactivated successfully',
		'PATTERN': 'Pattern',
		'PATTERN.END_AT_ENTRANCE': 'End at entrance',
		'PATTERN.START': 'Pattern start/end',
		'PATTERN.START_AT_ENTRANCE': 'Start at entrance',
		'PAUSE': 'Pause',
		'PERFORMANCE.AVERAGE': 'Средняя производительность',
		'PERFORMANCE.AVERAGE.EXPLAINATION': 'В этом значении также учитываются все рабочие состояния, включая время на подготовку и дорогу',
		'PERFORMANCE.AVERAGE.FIELD': 'Средняя производительность (поле)',
		'PERFORMANCE.AVERAGE.FIELD.EXPLAINATION': 'Это значение учитывает только работу на поле, ожидание на поле и включение поля',
		'PERFORMANCE.TOTAL': 'Общая производительность',
		'PHONE': 'Контактный номер телефона',
		'PHONE.INVALID': 'Телефон недействителен',
		'PHONE_MOBILE': 'Телефон(мобильный)',
		'PH_VALUE': 'Значение PH',
		'PLAY': 'Play',
		'POSTCODE': 'Почтовый индекс',
		'PREVIOUS': 'Предыдущий',
		'PROCESS': 'Процесс',
		'PROCESSED': 'Обработано',
		'PROCESSED.FAILURE': 'Сбой при обработке',
		'PROCESSED.SUCCESSFULL': 'Успешно обработано',
		'PRODUCT': 'Продукт',
		'PROGRESS': 'Прогресс',
		'PROJECTION': 'Проекция',
		'RAW_DATA': 'Необработанные данные',
		'RECEIVED.AT': 'Получено в',
		'REGENERATE': 'Восстановить',
		'REGENERATE.SELECTED': 'Восстановить выбранное',
		'REGISTER': 'Зарегистрироваться',
		'REGISTER.ALREADY_REGISTERED?': 'Уже зарегистрированы?',
		'REGISTER.I_ACCEPT_THE': 'Я принимаю',
		'RELOAD': 'Перезагрузить',
		'REMOVE': 'Удалить',
		'RENEW': 'Восстановить',
		'REOCURRING': 'Исправление',
		'REPORT': 'Отчет',
		'RESET': 'Сброс настроек',
		'RESOLUTION': 'Разрешение',
		'RESTORE.DRIVER': 'Восстановление драйвера',
		'RESTORE.IMPLEMENT': 'Восстановить реализацию',
		'ROAD': 'Дорога',
		'ROLE': 'Роль',
		'RUNTIME_H': 'Время работы в часах',
		'SAFETY_CHECK': 'Проверка безопасности',
		'SATELITE': 'Спутник',
		'SAVE': 'Сохранить',
		'SCALE.TYPE': 'Тип шкалы',
		'SEARCH': 'Поиск',
		'SEASON_YEAR': 'Сезон',
		'SEASON_YEAR.START': 'Начало сезона',
		'SELECT.ALL': 'Выбрать все',
		'SELECT.CLEAR': 'Снять выделение',
		'SELECT.FIELD': 'Select field',
		'SENSORDATA': 'Данные датчика',
		'SENSORDATA.DESCRIPTION': 'Визуализация данных датчика',
		'SENSORDATA.SELECT_SENSOR': 'Выбрать датчик',
		'SENSORDATA.SHOW_WORKSTATE_COLORS': 'Показать цвета рабочих состояний',
		'SENSOR_PARAMETER': 'Параметр датчика',
		'SENSOR_PARAMETER.ADD': 'Добавить параметр датчика',
		'SENSOR_PARAMETER.DEFINE_FOR_IMPLEMENT': 'Определите индивидуальные параметры датчика для выбранного оборудования.',
		'SENSOR_PARAMETER.DEFINE_INDIVIDUAL_PARAM': 'Определите индивидуальный параметр датчика.',
		'SENSOR_PARAMETER.INDIVIDUAL_SENSOR_PARAM': 'Индивидуальный параметр датчика',
		'SENSOR_PARAMETER.NOT_REMOVABLE_USED_IN_OTHER_PARAMETER': 'Параметр датчика используется в другой конфигурации параметра',
		'SENSOR_PARAMETERS': 'Параметры датчика',
		'SENSOR_PARAMETERS.NO': 'Нет параметров датчика',
		'SERIAL': 'Серийный номер',
		'SETTINGS': 'Настройки',
		'SETTINGS.ADDITIONAL': 'Additional settings',
		'SETTINGS.ADVANCED': 'Advanced settings',
		'SETTINGS.AGRIROUTER_CAN_BE_CONNECTED': 'Ваш аккаунт Agrirouter можно подключить к exatrek для обмена данными.',
		'SETTINGS.AGRIROUTER_CONNECTED_AND_READY': 'Agrirouter подключен и готов к использованию. Подключение действительно до',
		'SETTINGS.CONNECTION_TO_PARTNERS': 'Подключение к партнерам exatrek',
		'SETTINGS.FARMNET_FIELD_SYNC': 'Синхронизируйте поля из 365farmnet с exatrek',
		'SETTINGS.FARMNET_IMPLEMENT_SYNC': 'Синхронизируйте оборудование из 365farmnet с exatrek',
		'SETTINGS.FARMNET_MACHINE_SYNC': 'Синхронизируйте оборудование из 365farmnet с exatrek',
		'SETTINGS.GO_TO_FARMNET': 'Перейти к 365 FARMNET',
		'SETTINGS.ONLY_FARMNET_WEBAPP': 'Синхронизацию с 365farmnet можно использовать только из веб-приложения 365farmnet.',
		'SHOW': 'Показать',
		'SHOW_DIRECTION': 'Показать направления',
		'SHOW_EVENTS': 'Показать события',
		'SHOW_FIELDS': 'Показать поля',
		'SHOW_LOCATIONS': 'Показать местоположения',
		'SHOW_OFFLINE_MACHINES': 'Показать машины оффлайн',
		'SHOW_TRACKS': 'Показать маршруты',
		'SHOW_TRACKS_': 'Показать маршруты',
		'SNACKBAR.DAYS': 'Дни',
		'SNACKBAR.LICENSE_EXPIRATION_WARNING': 'Срок действия вашей лицензии истекает через',
		'SNACKBAR.MACHINE_ONLINE_WARNING': 'По крайней мере, одна машина какое-то время не была в сети!',
		'SORT_BY': 'Отсортировано по',
		'SPEED': 'Скорость',
		'SPEED.AVERAGE': 'Средняя скорость',
		'SPEED.FASTER': 'Faster',
		'SPEED.RESET': 'Reset speed',
		'SPEED.SIGNAL.OVERRIDE': 'Превышение скорости',
		'SPEED.SLOWER': 'Slower',
		'SPEED.WORKING': 'Working speed',
		'SPLIT': 'Деление',
		'START': 'Начало',
		'STATISTICS': 'Statistics',
		'STATUS': 'Статус',
		'STOP': 'Стоп',
		'STORAGE': 'Хранение',
		'STORAGE.USB': 'USB-накопитель',
		'STORAGE.USB.USED': 'Используемый USB-накопитель',
		'STORAGE.USED': 'Используемое хранилище',
		'SYMBOLIZATION': 'Символизация',
		'TASK': 'Задача',
		'TASK.ADDABLE_JOBS': 'Добавляемые работы',
		'TASK.ADD_JOBS': 'Добавить работу к задаче',
		'TASK.ARCHIVED_JOB_WARNING': 'Эта задача содержит заархивированные работы и не будет отображаться полностью!',
		'TASK.DELETE.JOB.FAILURE': 'В задаче должна быть хотя бы одна работа!',
		'TASK.DELETE.JOB.QUESTION': 'Вы действительно хотите удалить задание?',
		'TASK.DELETE.JOB.SUCCESS': 'Работа успешно удалена из задачи',
		'TASK.DELETE.QUESTION': 'Вы действительно хотите удалить задачу?',
		'TASK.DELETE.SUCCESS': 'Задача успешно удалена',
		'TASK.EDIT': 'Редактировать задачу',
		'TASK.EDIT.SUCCESS': 'Задача успешно отредактирована',
		'TASK.EXPORT_DETAILS': 'Экспорт выбранной задачи',
		'TASK.JOBS_TO_ADD': 'Работы к добавлению',
		'TASK.NEW': 'Новая задача',
		'TASKS': 'Задачи',
		'TASKS.NO': 'Нет задач',
		'TASK_CONTROLLER.ACTIVE': 'Активен контроллер задач (DataLog)',
		'TASK_CONTROLLER.COMPAT_ACTIVE': 'Режим совместимости контроллера задач',
		'TAX_ID': 'ИНН',
		'TC': 'TaskController',
		'TC.ACTIVE': 'TC active',
		'TC.TC_COMP': 'TC comp.',
		'TERMINAL.NO': 'Терминал отсутствует',
		'TERMINAL.TYPE': 'Тип терминала ',
		'TEST.SUCCESS': 'Запрос выполнен успешно. Скоро вы получите электронное письмо.',
		'TIME': 'Время',
		'TIME.REMAINING': 'Оставшееся время',
		'TIMEZONE': 'Часовой пояс',
		'TITLE': 'Запросить тестовый аккаунт',
		'TOKEN': 'Код доступа',
		'TOTAL': 'Общий',
		'TRACKS.LOADING': 'Загрузка маршрутов...',
		'TRACK.WIDTH': 'Ширина колеи',
		'TRACK.WIDTH.NARROW': 'Узкий',
		'TRACK.WIDTH.NORMAL': 'Нормальный',
		'TRACK.WIDTH.WIDE': 'Широкий',
		'TRACK_LENGTH': 'Длина пути',
		'TRACK_REPLAY': 'Track replay',
		'TRANSLATABLE': 'Переводимый',
		'TRANSLATABLE.ADD': 'Добавить возможность перевода',
		'TRANSLATION': 'Перевод',
		'TRANSPORT': 'Транспорт',
		'TRANSPORT/AXLES': 'Транспорт/Оси',
		'TRANSPORTAMOUNT_AXLES': 'Количество транспорта/Оси',
		'TURNINGS': 'Turnings',
		'TURNING_OFFSET': 'Turning offset',
		'TURNING_RADIUS': 'Turning radius',
		'TYPE': 'Тип',
		'UNDO': 'Отмена',
		'UNIT': 'Единица измерения',
		'UNKNOWN': 'Неизвестно',
		'UNTIL': 'до',
		'UPLOAD': 'Загрузить',
		'UPLOAD.FINISHED': 'Загрузка завершена',
		'UPLOADING': 'Загрузка',
		'USER.EDIT.SUCCESS': 'Пользователь успешно отредактирован',
		'USERNAME': 'Имя пользователя',
		'USERNAME.LENGTH.REQUIRED': 'Имя пользователя должно быть не менее 6 символов.',
		'USERNAME.TAKEN': 'Такое имя уже существует',
		'USERNAME.VALID.CHARS': 'Имя пользователя может содержать только буквы, цифры, «-» и «_».',
		'USERROLE': 'Роль пользователя',
		'USERSTATUS': 'Статус пользователя',
		'USER_CREATED': 'Пользователь создан',
		'WAITING': 'Ожидание',
		'WARNING': 'Предупреждение',
		'WEEK.CURRENT': 'Текущая неделя',
		'WEEK.NEXT': 'Следующая неделя',
		'WEEK.PREVIOUS': 'Предыдущая неделя',
		'WEEK.SELECTED': 'Выбранная неделя',
		'WEIGHING': 'Взвешивание',
		'WIDTH.INVALID': 'Недопустимая ширина',
		'WORKING_HOURS': 'Часы работы',
		'WORKING_TIME': 'Время работы',
		'WORKING_WIDTH': 'Рабочая ширина',
		'WORKSTATE': 'Рабочее состояние',
		'WORKSTATES': 'Рабочие состояния',
		'YES': 'Да',
    'NO_POSITION_MACHINE_FOUND': 'Позиционная машина не найдена',
	}
};
